// English source text is the key; the value is its Persian translation.
export const fa: Record<string, string> = {
  Camera: "دوربین",
  "Orders and grid": "فرمان‌ها و جدول",
  Strikes: "حملات ویژه",
  Global: "عمومی",
  Modifiers: "کلیدهای کمکی",
  "Pan up": "حرکت به بالا",
  "Pan down": "حرکت به پایین",
  "Pan left": "حرکت به چپ",
  "Pan right": "حرکت به راست",
  "Rotate left": "چرخش به چپ",
  "Rotate right": "چرخش به راست",
  Reset: "بازنشانی",
  "Hold Position": "حفظ موقعیت",
  "Formation Shape": "آرایش",
  "Hold Fire": "توقف آتش",
  Bomber: "بمب‌افکن",
  Alert: "هشدار",
  "Idle Builder": "سازندهٔ بیکار",
  Details: "جزئیات",
  "Bind Group": "ثبت گروه",
  Change: "تغییر",
  "Change {0}": "تغییر {0}",
  "Reset {0}": "بازنشانی {0}",
  "Reset all": "بازنشانی همه",
  "Press a key · Escape cancels": "کلیدی را فشار دهید · Escape لغو می‌کند",
  "{0} is assigned to {1}.": "کلید {0} به {1} اختصاص دارد.",
  "{0} is a fixed shortcut.": "{0} یک میان‌بر ثابت است.",
  Swap: "جابجایی",
  "Toggle queue and add to selection": "تغییر وضعیت صف و افزودن به انتخاب با یک فشار",

  "During peace, build inside your zone. Trucks may use shared supplies.":
    "توی زمان صلح، داخل محدودهٔ خودت بساز. کامیون‌ها می‌تونن از منابع مشترک استفاده کنن.",
  "Peace duration": "مدت صلح",
  "{0} min": "{0} دقیقه",
  "Peace · {0}": "صلح · {0}",
  "Peace ends in {0} seconds": "صلح تا {0} ثانیهٔ دیگه تموم می‌شه",
  "Battle begins": "نبرد شروع شد",
  "Combat is disabled until peace ends": "تا پایان صلح نمی‌تونی حمله کنی",
  "Build inside your starting zone until peace ends": "تا پایان صلح، توی محدودهٔ شروع خودت بساز",
  "Keep this supply area and truck route clear": "این محوطهٔ منابع و مسیر کامیون‌ها رو باز نگه دار",
  "Neutral supply area · Trucks allowed": "منطقهٔ بی‌طرف منابع · عبور کامیون آزاده",
  "Choose a peace duration from 0 to 30 minutes.": "مدت صلح رو بین ۰ تا ۳۰ دقیقه انتخاب کن.",
  "peace-active": "تا پایان صلح نمی‌تونی حمله کنی",

  "Your forces are eliminated. You can watch the battle, chat, ping, or leave.":
    "نیروهای شما حذف شده‌اند. تماشای بازی، چت، پینگ و خروج همچنان در دسترس است.",
  Allies: "هم‌تیمی‌ها",
  Enemies: "حریف‌ها",
  Connected: "متصل",
  Disconnected: "اتصال قطع شده",
  "Connection unknown": "وضعیت اتصال مشخص نیست",
  "Chat players": "بازیکنان چت",
  "Mute {0}": "بی‌صدا کردن {0}",
  "Unmute {0}": "لغو بی‌صدا بودن {0}",
  "Team chat · Enter / All · Shift+Enter": "چت تیمی · Enter / چت عمومی · Shift+Enter",
  "View {0}": "نمایش نیروهای {0}",
  "No visible forces": "نیرویی در دید نیست",
  "Team presets": "چیدمان‌های تیمی",
  "2v2": "۲ در برابر ۲",
  "3v3": "۳ در برابر ۳",
  "4v4": "۴ در برابر ۴",
  "Co-op": "همکاری در برابر هوش مصنوعی",
  "Occupied seats do not fit this preset.": "جایگاه‌های پرشده با این چیدمان جور نیستند.",
  "Teams have different sizes or human counts. You can still start.":
    "تعداد نفرات یا بازیکنان انسانی تیم‌ها برابر نیست؛ شروع بازی همچنان ممکن است.",
  "ALLY BASE UNDER ATTACK · {0}": "پایگاه هم‌تیمی زیر حمله است · {0}",
  "ALLY UNIT UNDER ATTACK · {0}": "نیروی هم‌تیمی زیر حمله است · {0}",
  "Change map": "تغییر نقشه",
  "Choose a map": "انتخاب نقشه",
  Multiplayer: "چندنفره",
  PREFERENCES: "تنظیمات",
  "SAVES AND RECORDS": "ذخیره‌ها و ضبط‌ها",
  "vs AI · {0}": "در برابر هوش مصنوعی · {0}",
  Forces: "نیروها",
  Difficulty: "سختی",
  "Play here": "بازی از اینجا",
  "{0} open rooms": "{0} اتاق باز",
  "Drop a file on a card to open it.": "برای باز کردن، فایل را روی کارت رها کنید.",
  Mode: "حالت",
  "PLAY ONLINE": "بازی آنلاین",
  "Pick the map, seats, AI and rules in the lobby while players join.":
    "نقشه، جایگاه‌ها، هوش مصنوعی و قوانین را در لابی تنظیم کنید تا بازیکنان بپیوندند.",
  "Join with code": "پیوستن با کد",
  Pause: "مکث",
  Play: "اجرا",
  Unknown: "نامشخص",
  Construction: "ساخت",
  "Drone pad": "سکوی پهپاد",
  "Drone home": "پایگاه پهپاد",
  "Drone phase": "مرحلهٔ پهپاد",
  Slot: "جایگاه",
  Home: "پایگاه",
  Altitude: "ارتفاع",
  Ammo: "مهمات",
  "Flight phase": "مرحلهٔ پرواز",
  "Open a preset directly: /play?sandbox&preset=<name>":
    "باز کردن مستقیم الگو: /play?sandbox&preset=<name>",
  "Give to side": "واگذاری به طرف",
  "Set HP 10%": "سلامت ۱۰٪",
  "Set HP 50%": "سلامت ۵۰٪",
  "Select something on the map to inspect it.": "برای بررسی، چیزی را روی نقشه انتخاب کنید.",
  "Training, construction, upgrades finish next tick":
    "آموزش، ساخت و ارتقا در تیک بعد پایان می‌یابند",
  "No low-power slowdown": "بدون کاهش سرعت در کمبود برق",
  "No building prerequisites": "بدون پیش‌نیاز ساختمان",
  "Money stays topped up": "منابع مالی همیشه پر می‌مانند",
  "No fog for any side": "بدون مه برای همهٔ طرف‌ها",
  "Placing {0} for {1} — click map · Esc to finish":
    "در حال ایجاد {0} برای {1} — روی نقشه کلیک کنید · Esc برای پایان",
  "Place for": "ایجاد برای",
  Save: "ذخیره",
  Inspect: "بررسی",
  World: "جهان",
  "Sandbox sections": "بخش‌های محیط آزمایش",
  Tick: "تیک",
  "Toggle sandbox panel": "باز و بسته کردن پنل آزمایش",
  "Step 1 tick": "یک تیک جلو",
  "Run / pause": "اجرا / مکث",
  "Recon unavailable": "پهپاد شناسایی در دسترس نیست",
  "DRONE STRIKE": "حملهٔ پهپادی",
  "BOMBING RUN": "حملهٔ بمب‌افکن",
  "CRUISE MISSILE": "موشک کروز",
  RECON: "شناسایی",
  "Click a target (map or minimap)": "هدف را در میدان یا نقشه انتخاب کنید",
  "Shift keep aiming": "Shift ادامهٔ نشانه‌گیری",
  "Esc / right-click cancel": "Esc / راست‌کلیک لغو",
  "Click the centre · drag to turn it": "مرکز را انتخاب کنید · برای چرخش بکشید",
  "Friendly fire: your units, buildings and allies take damage.":
    "آتش خودی: نیروها و ساختمان‌های خودی و هم‌تیمی‌ها هم آسیب می‌بینن.",
  "R repeat {0}": "R تکرار {0}",
  "Esc cancel": "Esc لغو",
  ON: "روشن",
  OFF: "خاموش",
  "radius {0}": "شعاع {0}",
  "run {0} × {1}": "مسیر {0} × {1}",
  "impact in {0}s · radius {1} / {2}": "برخورد پس از {0} ثانیه · شعاع {1} / {2}",
  "reveal radius {0}": "شعاع دید {0}",
  "{0} +1 · wheel ±1 · 1–9 exact": "{0} +۱ · چرخ ماوس ±۱ · ۱–۹ دقیق",
  "Strike rail": "نوار حمله",
  "send ×{0}": "اعزام ×{0}",
  "Bomber status": "وضعیت بمب‌افکن‌ها",
  "Toggle bomber repeat": "تغییر تکرار حملهٔ بمب‌افکن‌ها",
  "Return bombers to base": "بازگشت بمب‌افکن‌ها به پایگاه",
  "Toggle recon repeat": "تغییر تکرار مأموریت شناسایی",
  "Return recon drones to base": "بازگشت پهپادهای شناسایی به پایگاه",
  "Silo {0}: {1}": "سیلو {0}: {1}",
  "Prepare missile": "آماده‌سازی موشک",
  "Prepare missile · right-click cancels": "آماده‌سازی موشک · راست‌کلیک لغو",
  "Missile timers": "زمان‌سنج موشک‌ها",
  "{0}: {1} ready, {2} preparing": "{0}: {1} آماده، {2} در حال آماده‌سازی",
  airborne: "در پرواز",
  preparing: "در حال آماده‌سازی",
  empty: "خالی",

  Sandbox: "محیط آزمایش",
  "Sandbox slot not found.": "جایگاه محیط آزمایش پیدا نشد.",
  "Placed {0} × {1}": "{1} عدد {0} قرار گرفت",
  Place: "قرار دادن",
  "Presets…": "چیدمان‌ها…",
  "Preset partly placed ({0} skipped)": "چیدمان ناقص قرار گرفت ({0} مورد رد شد)",
  "Invalid preset name": "نام چیدمان نامعتبر است",
  "Select at least one entity": "دست‌کم یک واحد یا ساختمان انتخاب کنید",
  "Could not save preset": "ذخیره چیدمان ممکن نشد",
  "Your side: {0}; other sides: {1}": "سمت شما: {0}؛ سمت‌های دیگر: {1}",
  "Place preset {0}": "قرار دادن چیدمان {0}",
  "Delete preset {0}": "حذف چیدمان {0}",
  "Click the battlefield to place {0}. Right-click or Escape to finish.":
    "برای قرار دادن {0} روی میدان کلیک کنید. برای پایان راست‌کلیک کنید یا Escape را بزنید.",
  "New preset from selection": "چیدمان جدید از انتخاب",
  "Preset name": "نام چیدمان",
  "Preset saved": "چیدمان ذخیره شد",
  "Preset placed": "چیدمان آماده قرار گرفت",
  "Invalid slot name": "نام جایگاه نامعتبر است",
  "Could not save sandbox slot": "ذخیرهٔ جایگاه محیط آزمایش ممکن نشد",
  "Sandbox controls": "کنترل‌های محیط آزمایش",
  "Open sandbox": "ورود به محیط آزمایش",
  "Build scenarios freely. Start paused, place either side, then run the simulation. No AI, elimination, or time limit.":
    "سناریوی دلخواهتان را بسازید. شبیه‌سازی از ابتدا متوقف است؛ نیروهای هر طرف را بچینید و بعد اجرا کنید. هوش مصنوعی، حذف بازیکن و محدودیت زمانی غیرفعال‌اند.",
  "Manual control": "کنترل دستی",
  "Simulation stopped": "شبیه‌سازی متوقف است",
  "Run simulation": "اجرای شبیه‌سازی",
  "Stop simulation": "توقف شبیه‌سازی",
  "1 tick": "یک تیک",
  "1 second": "یک ثانیه",
  "Control side": "کنترل طرف نبرد",
  "Reveal map": "نمایش کامل نقشه",
  "Free resources": "منابع نامحدود",
  "Add $10,000": "افزودن ۱۰٬۰۰۰ دلار",
  Buildings: "ساختمان‌ها",
  Catalog: "فهرست",
  "Search catalog": "جست‌وجو در فهرست",
  "Place entity": "انتخاب نیرو یا ساختمان",
  "Place on map": "قرار دادن روی نقشه",
  "Finish placing": "پایان چیدن",
  "Click the battlefield to place. Right-click or Escape to finish.":
    "برای قرار دادن روی میدان نبرد کلیک کنید. برای پایان، راست‌کلیک کنید یا Escape را بزنید.",
  "Choose any active unit or building. Placement is instant and free.":
    "هر نیرو یا ساختمان فعالی را انتخاب کنید. قرار دادن آن فوری و رایگان است.",
  "Heal / rearm selection": "ترمیم و تسلیح انتخاب‌شده‌ها",
  "Clear battlefield": "خالی کردن میدان نبرد",
  "Confirm clear battlefield": "تأیید خالی کردن میدان نبرد",
  "Save scenario": "ذخیرهٔ سناریو",
  "Scenario saved. Load it through the pause menu or Archive.":
    "سناریو ذخیره شد. از منوی توقف یا آرشیو آن را بارگذاری کنید.",
  "Aircraft and drones need an Airbase. Silos start armed. Remove selection advances one tick.":
    "هواگردها و پهپادها به پایگاه هوایی نیاز دارند. سیلوها از ابتدا مسلح‌اند. حذف انتخاب‌شده‌ها شبیه‌سازی را یک تیک جلو می‌برد.",
  "Invalid sandbox mode.": "حالت محیط آزمایش نامعتبر است.",
  "Save this sandbox as a scenario instead of a battle record.":
    "این محیط آزمایش را به‌صورت سناریو ذخیره کنید، نه بازپخش نبرد.",
  "Place an Airbase with a free drone pad first.":
    "اول یک پایگاه هوایی با سکوی پهپاد خالی قرار دهید.",
  "Placed {0}": "{0} قرار گرفت",
  "Click to place instantly": "برای قرار دادن فوری کلیک کنید",
  "Invalid side": "طرف نبرد نامعتبر است",
  "Invalid kind": "نوع انتخاب‌شده نامعتبر است",
  "Invalid coordinates": "مختصات نامعتبر است",
  "{0} · {1} HP": "{0} · {1} جان",
  Simulation: "شبیه‌سازی",
  Rules: "قوانین",
  Spawn: "قرار دادن",
  Scenarios: "سناریوها",
  Count: "تعداد",
  Presets: "چیدمان‌های آماده",
  "Air test": "آزمایش هوایی",
  "Full base": "پایگاه کامل",
  "Unlock all tech": "آزاد کردن همهٔ فناوری‌ها",
  "Unlimited power": "برق نامحدود",
  "Instant production": "تولید فوری",
  Inspector: "بازرسی",
  Kind: "نوع",
  Owner: "مالک",
  "Position (tiles)": "موقعیت (خانه)",
  Order: "دستور",
  Cooldown: "زمان انتظار",
  Flight: "پرواز",
  Drone: "پهپاد",
  Progress: "پیشرفت",
  Copy: "کپی",
  "Could not copy inspection.": "کپی اطلاعات بازرسی ممکن نشد.",
  "Slot name": "نام جایگاه",
  "Quick save": "ذخیرهٔ سریع",
  "Quick save complete.": "ذخیرهٔ سریع انجام شد.",
  Load: "بارگذاری",
  Delete: "حذف",
  "Confirm delete": "تأیید حذف",
  "Slot not found.": "جایگاه پیدا نشد.",
  "Scenario loaded.": "سناریو بارگذاری شد.",
  "Open a slot directly: /play?sandbox=<name>": "باز کردن مستقیم جایگاه: /play?sandbox=<name>",
  "Mission options": "گزینه‌های مأموریت",
  "Produces Buggies, Striders, Hover batteries, and Bombard walkers.":
    "باگی، استرایدر، آتشبار شناور و بمبارد تولید می‌کند.",
  "Occupant evacuation pending": "خروج نیروها در انتظار تأیید",
  "Occupants evacuated": "نیروها خارج شدند",
  "Exit blocked or bunker unavailable": "راه خروج بسته است یا سنگر در دسترس نیست",
  "Recon: 30s mission · Powered service {0}s":
    "شناسایی: مأموریت ۳۰ ثانیه‌ای · آماده‌سازی با برق {0} ثانیه",
  "Three bombs per pass · Powered service {0}s": "سه بمب در هر حمله · آماده‌سازی با برق {0} ثانیه",
  "Strike bomber": "بمب‌افکن تهاجمی",
  "Attack drone": "پهپاد انتحاری",
  "SAM tower": "برج پدافند هوایی",
  "Infantry bunker": "سنگر پیاده‌نظام",
  Recon: "شناسایی",
  Redirect: "تغییر هدف",
  Return: "بازگشت",
  "Repeat missions": "تکرار مأموریت",
  "All ready": "همهٔ آماده‌ها",
  "{0} group size": "تعداد گروه {0}",
  "Aircraft ×{0}": "هواگردها ×{0}",
  "Player {0}: missile {1}": "بازیکن {0}: موشک {1}",
  "Drone strike ×{0}": "حملهٔ پهپادی ×{0}",
  "Drones ×{0} · radius {1} · {2}–{3}s": "پهپادها ×{0} · شعاع {1} · {2}–{3} ثانیه",
  "Recon patrol · radius {0}": "گشت شناسایی · شعاع {0}",
  "Bombing run · {0} bombs · length {1}": "بمباران · {0} بمب · طول {1}",
  "{0} · drag to set the area": "{0} · برای تعیین محدوده بکشید",
  "Return to base": "بازگشت به پایگاه",
  "Bunker occupants": "نیروهای داخل سنگر",
  "Occupancy {0}/3": "ظرفیت {0} از ۳",
  "Eject occupant {0}": "خروج نیروی {0}",
  "Eject all": "خروج همه",
  "Eject all occupants": "خروج همهٔ نیروها",
  "Select combat infantry and right-click the bunker to enter. Blocked exits prevent evacuation.":
    "پیاده‌نظام رزمی را انتخاب کنید و روی سنگر راست‌کلیک کنید تا وارد شود. اگر راه خروج بسته باشد، نیروها نمی‌توانند خارج شوند.",
  "Protected infantry firing position": "موضع محافظت‌شدهٔ پیاده‌نظام",
  "Four bomber hangars, five attack-drone racks, and one dedicated recon bay. Purchase replacements explicitly.":
    "چهار جایگاه بمب‌افکن، پنج سکوی پهپاد انتحاری و یک جایگاه شناسایی. هواگرد جایگزین را خودتان بخرید.",
  "Moving bombing pass with three bombs. Returns and services automatically; repeat missions start off.":
    "در حال حرکت سه بمب رها می‌کند. خودکار برمی‌گردد و آماده می‌شود؛ تکرار مأموریت در ابتدا خاموش است.",
  "Purchased recon drone. Scouts for 30 seconds including travel, then returns for 15 seconds of powered service.":
    "پهپاد شناسایی خریداری‌شده، با احتساب زمان پرواز ۳۰ ثانیه شناسایی می‌کند؛ سپس برای آماده‌سازی ۱۵ ثانیه‌ای با برق برمی‌گردد.",
  "Expendable precision attack against vehicles. Every survivor delivers its payload; departure frees its preparation rack.":
    "حملهٔ دقیق و یک‌بارمصرف به خودروها. هر پهپاد سالم محموله‌اش را منفجر می‌کند؛ با پرواز، سکوی آماده‌سازی آزاد می‌شود.",
  "Three combat-infantry spaces. Ground weapons gain double range and 25% more damage. Survivors leave with half their current HP when destroyed. Click a portrait to eject.":
    "جا برای سه پیاده‌نظام رزمی. برد سلاح‌های زمینی دو برابر و آسیبشان ۲۵٪ بیشتر می‌شود. با تخریب سنگر، نیروها با نصف سلامت فعلی خارج می‌شوند. برای خروج هر نیرو روی تصویرش کلیک کنید.",
  "Use Recon, Drone strike, or Bombing run above the minimap. Choose a target on the battlefield or minimap. The ready group is frozen; {0} or right-click cancels.":
    "از فرمان شناسایی، حملهٔ پهپادی یا بمباران بالای نقشهٔ کوچک استفاده کنید. هدف را روی میدان یا نقشه انتخاب کنید. اعضای گروه ثابت می‌مانند؛ با {0} یا راست‌کلیک لغو کنید.",
  "Aircraft land without power. Powered service takes 12 seconds for bombers and 15 seconds for recon. Repeat missions start off. Return cancels repeats. Redirect preserves remaining payload and mission time.":
    "هواگردها بدون برق هم فرود می‌آیند. آماده‌سازی با برق برای بمب‌افکن ۱۲ ثانیه و برای شناسایی ۱۵ ثانیه طول می‌کشد. تکرار مأموریت در ابتدا خاموش است. بازگشت، تکرار را لغو می‌کند. تغییر هدف، محموله و زمان باقی‌مانده را حفظ می‌کند.",

  "{0} selected · Group ranges hidden · Hover a selected unit to inspect":
    "{0} انتخاب شده · محدوده‌های گروه پنهان است · برای بررسی، نشانگر را روی یک یگان انتخاب‌شده ببرید",
  "Jump to alert": "رفتن به محل هشدار",
  Ping: "علامت نقشه",
  "Minimap size": "اندازهٔ نقشهٔ کوچک",
  "{0} Upgrade · {1} Rally · {2} Sell": "{0} ارتقا · {1} محل تجمع · {2} فروش",
  "Building actions": "فرمان‌های ساختمان",
  Rally: "محل تجمع",
  Sell: "فروش",
  "{0} Base · {1} Defence · {2} Infantry · {3} Vehicles · {4} Air":
    "{0} پایگاه · {1} دفاع · {2} پیاده‌نظام · {3} خودروها · {4} هوایی",
  Categories: "دسته‌ها",
  "Cycle formation shape ({0})": "تغییر شکل آرایش ({0})",
  Bombers: "بمب‌افکن‌ها",
  "Bombers ×{0}": "بمب‌افکن‌ها ×{0}",
  "{0} · {1}": "{0} · {1}",
  "Bombers unavailable": "بمب‌افکن‌ها در دسترس نیستند",
  "Target area": "هدف‌گیری محدوده",
  "{0} {1}": "{0} {1}",
  "{0} servicing · {1} in flight": "{0} در حال سرویس · {1} در پرواز",
  "BOMBER STRIKE · SELECT A POSITION · {0} TO CANCEL":
    "حملهٔ بمب‌افکن · یک موقعیت انتخاب کنید · لغو با {0}",
  "Open an Airbase button on the left to choose a drone type or bomber area strike, then click the battlefield or minimap. Only drones ready when targeting starts join that launch; {0} or right-click cancels targeting.":
    "دکمهٔ پایگاه هوایی در سمت چپ را باز کنید و نوع پهپاد یا حملهٔ محدوده‌ای بمب‌افکن را انتخاب کنید، سپس روی میدان نبرد یا نقشهٔ کوچک کلیک کنید. فقط پهپادهای آماده در شروع هدف‌گیری پرتاب می‌شوند؛ {0} یا راست‌کلیک هدف‌گیری را لغو می‌کند.",
  "Ground tower": "برج دفاع زمینی",
  "About 5 minutes · No timed enemy raids": "حدود ۵ دقیقه · بدون حملات زمان‌بندی‌شدهٔ دشمن",
  "Trains Rifle infantry, Grenadiers, Rocket infantry, and Engineers.":
    "تفنگ‌دار، نارنجک‌انداز، راکت‌انداز و مهندس آموزش می‌دهد.",
  "Ground-only rapid-fire defense. Requires power; no weapon upgrades.":
    "دفاع سریع‌شلیک فقط علیه زمین؛ نیازمند برق و بدون ارتقای سلاح.",
  "Upgrades a Power plant's output. The plant keeps working during installation.":
    "توان نیروگاه را افزایش می‌دهد؛ نیروگاه هنگام نصب همچنان کار می‌کند.",
  "Select a Power plant to buy its turbine upgrade after building a Radar station":
    "پس از ساخت ایستگاه رادار، نیروگاه را برای خرید ارتقای توربین انتخاب کنید.",
  "Select Bombard walkers and use Deploy / Undeploy":
    "بمباردها را انتخاب کنید و از استقرار / جمع‌کردن استفاده کنید.",
  "This match uses the shared roster.": "این مسابقه از فهرست یگان‌های مشترک استفاده می‌کند.",
  "You can change an allowed team; the host can configure AI seats.":
    "می‌توانید تیم مجاز را تغییر دهید؛ میزبان می‌تواند جایگاه‌های هوش مصنوعی را تنظیم کند.",
  "Reusable bomber. Attacks its assigned target once, then returns to rearm.":
    "بمب‌افکن چندبارمصرف؛ یک بار به هدف تعیین‌شده حمله می‌کند و برای تجدید مهمات بازمی‌گردد.",
  "Prepare drones at an Airbase. Each base and type has a persistent left-bar swarm. Select its row, then click the battlefield or the minimap. Only drones ready when targeting starts join that launch; Escape or right-click cancels targeting.":
    "پهپادها را در پایگاه هوایی آماده کنید. هر پایگاه و نوع، گروه ثابتی در نوار چپ دارد. ردیف آن را انتخاب کنید، سپس روی میدان نبرد یا نقشهٔ کوچک کلیک کنید. فقط پهپادهای آماده در آغاز هدف‌گیری پرتاب می‌شوند؛ Escape یا راست‌کلیک هدف‌گیری را لغو می‌کند.",
  "Aircraft resupply": "تجدید مهمات هواگردها",
  "Purchase a cruise missile at a Strike center, wait for Ready, then select Missile on the left bar and click a target. Low power pauses preparation; {0} or right-click cancels targeting.":
    "یک موشک کروز در مرکز حمله بخرید و منتظر آماده‌شدن بمانید؛ سپس «موشک» را در نوار چپ انتخاب کنید و روی هدف کلیک کنید. کمبود برق آماده‌سازی را متوقف می‌کند؛ {0} یا راست‌کلیک هدف‌گیری را لغو می‌کند.",
  "DRONE SWARM · SELECT EXPLORED POSITION · {0} TO CANCEL":
    "گروه پهپاد · موقعیت کاوش‌شده را انتخاب کنید · لغو با {0}",
  Airbase: "پایگاه هوایی",
  "Flight Yard": "محوطهٔ پرواز",
  Witness: "گواه",
  Longbow: "کمان بلند",
  Spark: "جرقه",
  Firebird: "پرندهٔ آتشین",
  "Light drone": "پهپاد سبک",
  "Air and missile launches": "پرتاب هوایی و موشکی",
  Light: "سبک",
  "{0} {1} / {2} · {3}": "{0} {1} / {2} · {3}",
  "{0} ready": "{0} آماده",
  " · {0}s": " · {0} ثانیه",
  "Choose a target on battlefield or minimap": "هدفی را روی میدان یا نقشهٔ کوچک انتخاب کنید",
  "Airbase unavailable": "پایگاه هوایی در دسترس نیست",
  "Launch pending": "پرتاب در انتظار تأیید",
  "No drones ready": "پهپاد تهاجمی آماده‌ای نیست",
  "No bombers ready": "بمب‌افکن آماده‌ای نیست",
  "No recon drones ready": "پهپاد شناسایی آماده‌ای نیست",
  "No missile ready": "موشک آماده‌ای نیست",
  "No ready drones": "پهپاد آماده‌ای نیست",
  "Selected drones unavailable": "پهپادهای انتخاب‌شده در دسترس نیستند",
  "Outside battlefield": "خارج از میدان نبرد",
  "Swarm rejected ({0}).": "پرتاب گروه رد شد ({0}).",
  Resupply: "تجدید مهمات",
  "Return to battlefield": "بازگشت به میدان نبرد",
  "Repeat sorties": "تکرار مأموریت بمباران",
  "Will return": "بازخواهد گشت",
  "Will stay": "در پایگاه می‌ماند",
  "Awaiting assignment": "در انتظار مأموریت",
  "{0}s": "{0} ثانیه",
  "Aircraft order applied": "فرمان هوایی اجرا شد",
  "Aircraft order pending": "فرمان هوایی در انتظار تأیید",
  "Aircraft order rejected ({0}).": "فرمان هوایی رد شد ({0}).",
  takeoff: "در حال برخاستن",
  attacking: "در حال عملیات",
  returning: "در حال بازگشت",
  landing: "در حال فرود",
  rearming: "در حال تجدید مهمات",
  awaiting: "منتظر پایگاه",
  "Light single-use area strike": "ضربهٔ منطقه‌ای یک‌بارمصرف سبک",
  "Heavy single-use area strike": "ضربهٔ منطقه‌ای یک‌بارمصرف سنگین",
  "Four reusable aircraft strips and five shared drone launch pads. Paid drone preparation; launch by base and type from the left bar.":
    "چهار باند هواگرد و پنج سکوی مشترک پرتاب پهپاد. آماده‌سازی پولی پهپاد؛ پرتاب بر اساس پایگاه و نوع از نوار چپ.",
  "Prepare paid winged drones at an Airbase. Launch the ready group of this type from the left bar at any map position. Interception prevents the payload.":
    "پهپادهای بال‌دار را با پرداخت هزینه در پایگاه هوایی آماده کنید. گروه آمادهٔ این نوع را از نوار چپ به هر نقطه‌ای از نقشه بفرستید. رهگیری مانع انفجار می‌شود.",

  Retry: "تلاش مجدد",
  "Builders prefer local jobs and travel to distant construction sites; move supply trucks to establish a new area or order a specific supply route":
    "سازنده‌ها کارهای نزدیک را ترجیح می‌دهند و برای ساخت به محل‌های دور می‌روند؛ کامیون‌های تدارکات را برای تعیین محدودهٔ جدید جابه‌جا کنید یا مسیر تدارکاتی مشخصی بدهید",
  queued: "در صف",
  "Hover a tile for details": "برای جزئیات روی یک گزینه مکث کنید",
  "Construction and production categories": "دسته‌های ساخت و تولید",
  "No producer available": "ساختمان تولیدی در دسترس نیست",
  "Builder will travel to site · Click to build · {0} to queue":
    "سازنده به محل می‌رود · کلیک برای ساخت · {0} برای افزودن به صف",
  "Loading battlefield…": "در حال بارگیری میدان نبرد…",
  "Loading map data…": "در حال بارگیری داده‌های نقشه...",
  "Cannot load map data. Try again.": "بارگیری داده‌های نقشه ممکن نشد. دوباره تلاش کنید.",
  "Soostan Foothills": "دامنه‌های سوستان",
  "Download map data (ODbL 1.0)": "دریافت داده‌های نقشه (ODbL 1.0)",
  "1v1 · real geography · lagoon and lanes": "یک‌به‌یک · جغرافیای واقعی · مرداب و گذرگاه‌ها",
  "Soostan Foothills: a real Lahijan foothill crop with the Soostan lagoon, village lanes and terraced fields. Two opposed bases with several ground routes around the water.":
    "دامنه‌های سوستان: برشی واقعی از دامنه‌های لاهیجان با مرداب سوستان، کوچه‌های روستایی و شالیزارهای پله‌ای. دو پایگاه روبه‌رو با چند مسیر زمینی گرد آب.",
  "Map data © OpenStreetMap contributors (ODbL). Elevation: Mapzen Terrain Tiles (USGS SRTM/GMTED2010).":
    "داده‌های نقشه © مشارکت‌کنندگان OpenStreetMap (ODbL). ارتفاع: Mapzen Terrain Tiles (USGS SRTM/GMTED2010).",
  "Cannot load the battlefield. Try again.": "بارگیری میدان نبرد ممکن نشد. دوباره تلاش کنید.",
  "Training grounds": "میدان آموزش",
  "Meet your builder": "با سازنده آشنا شوید",
  "Click the highlighted builder to select it. Builders construct and repair your base.":
    "روی خودروی سازندهٔ مشخص‌شده کلیک کنید تا انتخاب شود. سازنده‌ها ساختمان‌های پایگاه شما را می‌سازند و تعمیر می‌کنند.",
  "Give your first order": "اولین دستور را بدهید",
  "Move your builder to the marked circle: right-click the ground, or left-click it with Trackpad controls on. Pan with {0} or the screen edges; scroll to zoom.":
    "سازنده را به دایرهٔ مشخص‌شده ببرید: روی زمین راست‌کلیک کنید، یا با «کنترل‌های ترک‌پد» روشن، روی آن کلیک چپ کنید. با کلیدهای {0} یا لبه‌های صفحه دوربین را جابه‌جا کنید؛ با چرخ ماوس بزرگ‌نمایی کنید.",
  "Power your base": "برق پایگاه را تأمین کنید",
  "Open Base ({0}) and choose Power plant, then click open ground near the marker. Wait for construction to finish. Power keeps production running at full speed.":
    "بخش «پایگاه» ({0}) را باز کنید و «نیروگاه» را انتخاب کنید؛ سپس روی زمین خالی نزدیک نشانه کلیک کنید. منتظر پایان ساخت بمانید. برق، تولید را با سرعت کامل نگه می‌دارد.",
  "Set up your income": "درآمدتان را راه بیندازید",
  "Choose Supply center in Base ({0}) and place it near the marked supply dock. It comes with a free Supply truck. Suggested sites are optional; any legal location works.":
    "در بخش «پایگاه» ({0})، «مرکز تدارکات» را انتخاب کنید و نزدیک انبار منابعِ مشخص‌شده بسازید. یک کامیون تدارکات رایگان هم دریافت می‌کنید. محل‌های پیشنهادی اختیاری‌اند؛ هر جای مجازی مناسب است.",
  "Meet your Supply truck": "با کامیون تدارکات آشنا شوید",
  "Click your free Supply truck. It automatically gathers supplies and delivers them to your Supply center.":
    "روی کامیون تدارکات رایگان کلیک کنید. کامیون به‌طور خودکار تدارکات جمع می‌کند و به مرکز تدارکات تحویل می‌دهد.",
  "Earn your first money": "اولین درآمدتان را کسب کنید",
  "Watch a supply delivery increase your money. If the truck is idle, select it and right-click the marked dock, or left-click it with Trackpad controls on.":
    "ببینید چطور تحویل تدارکات پولتان را بیشتر می‌کند. اگر کامیون بیکار است، آن را انتخاب کنید و روی انبار مشخص‌شده راست‌کلیک کنید، یا با «کنترل‌های ترک‌پد» روشن، روی آن کلیک چپ کنید.",
  "Build your Barracks": "پادگان بسازید",
  "Open Base ({0}), choose Barracks, and place it on open ground. This building trains your infantry.":
    "بخش «پایگاه» ({0}) را باز کنید، «پادگان» را انتخاب کنید و روی زمین خالی بسازید. این ساختمان پیاده‌نظام شما را آموزش می‌دهد.",
  "Train a small squad": "یک دستهٔ کوچک آموزش دهید",
  "Open Infantry ({0}) and click Rifle infantry three times. Each click queues one soldier. Wait for all three to leave the Barracks.":
    "بخش «پیاده‌نظام» ({0}) را باز کنید و سه بار روی «تفنگدار» کلیک کنید. هر کلیک یک سرباز به صف آموزش اضافه می‌کند. منتظر خروج هر سه سرباز از پادگان بمانید.",
  "Select your squad": "دستهٔ خود را انتخاب کنید",
  "Drag a selection rectangle around at least three soldiers. You can also {0}-click to add soldiers, or use Select rectangle on touch.":
    "با کشیدن ماوس، دست‌کم سه سرباز را در کادر انتخاب قرار دهید. برای افزودن سرباز می‌توانید {0} را نگه دارید و کلیک کنید، یا در حالت لمسی از «انتخاب مستطیلی» استفاده کنید.",
  "Take the enemy outpost": "پاسگاه دشمن را نابود کنید",
  "Move your squad toward the marked outpost. When its buildings appear, right-click them to attack, or left-click them with Trackpad controls on. Destroy every enemy building to win.":
    "دستهٔ خود را به‌سوی پاسگاه مشخص‌شده ببرید. وقتی ساختمان‌های دشمن دیده شدند، برای حمله روی آن‌ها راست‌کلیک کنید، یا با «کنترل‌های ترک‌پد» روشن، روی آن‌ها کلیک چپ کنید. برای پیروزی همهٔ ساختمان‌های دشمن را نابود کنید.",
  "Training supplies received. Missing builders and Supply trucks have been replaced.":
    "تدارکات آموزشی دریافت شد. سازنده‌ها و کامیون‌های تدارکات ازدست‌رفته جایگزین شدند.",
  "Step {0} of {1}": "مرحلهٔ {0} از {1}",
  "Your builder is missing. Use Training support to receive a replacement and continue.":
    "سازنده ندارید. با «پشتیبانی آموزشی» یک جایگزین دریافت کنید و ادامه دهید.",
  "LEARN TO PLAY": "آموزش بازی",
  "First Mission": "اولین مأموریت",
  "Build a base, earn money, and lead your first squad to victory.":
    "پایگاه بسازید، پول به دست بیاورید و اولین دستهٔ خود را به پیروزی برسانید.",
  "About 5 minutes · Bastion faction · No timed enemy raids":
    "حدود ۵ دقیقه · جناح باستین · بدون حمله‌های زمان‌بندی‌شدهٔ دشمن",
  "Select and move your builder.": "سازنده را انتخاب کنید و حرکت دهید.",
  "Build power and collect supplies.": "نیروگاه بسازید و تدارکات جمع کنید.",
  "Train infantry and destroy a small enemy outpost.":
    "پیاده‌نظام آموزش دهید و یک پاسگاه کوچک دشمن را نابود کنید.",
  "Follow one objective at a time. Highlights show where to act. Take as long as you need; training support and restart are always available.":
    "هر بار یک هدف را دنبال کنید. نشانه‌ها محل انجام کار را نشان می‌دهند. محدودیت زمانی ندارید؛ پشتیبانی آموزشی و شروع دوباره همیشه در دسترس‌اند.",
  "Replay First Mission": "تکرار اولین مأموریت",
  "Start First Mission": "شروع اولین مأموریت",
  "Skip introduction": "رد کردن آموزش",
  "First Mission objectives": "هدف‌های اولین مأموریت",
  "Show me": "نشانم بده",
  "Training support": "پشتیبانی آموزشی",
  "Restart mission": "شروع دوبارهٔ مأموریت",
  "Exit training": "خروج از آموزش",
  "Training support adds money and replaces missing builders or Supply trucks.":
    "پشتیبانی آموزشی پول اضافه می‌کند و سازنده‌ها یا کامیون‌های تدارکات ازدست‌رفته را جایگزین می‌کند.",
  Learn: "آموزش",
  "New here?": "تازه واردی؟",
  "Fast matches, small maps, no waiting. Jump into a room or start your own.":
    "نبردهای سریع، نقشه‌های کوچک، بدون انتظار. به یک اتاق بپیوندید یا اتاق خودتان را بسازید.",
  "{0} open": "{0} باز",
  "Learn to play": "آموزش بازی",
  "vs AI": "در برابر هوش مصنوعی",
  New: "جدید",
  "Recommended · ~5 minutes": "پیشنهادشده · حدود ۵ دقیقه",
  "Completed · Replay anytime": "تکمیل‌شده · تکرار در هر زمان",
  "~5 minutes · Optional": "حدود ۵ دقیقه · اختیاری",
  "Mission target": "هدف مأموریت",
  "Low power slows production. Build another Power plant to restore full speed.":
    "کمبود برق تولید را کند می‌کند. برای بازگشت به سرعت کامل یک نیروگاه دیگر بسازید.",
  "Train a Supply truck at a Supply center to keep earning money.":
    "برای ادامهٔ درآمد، در مرکز تدارکات یک کامیون تدارکات تولید کنید.",
  "Your Supply truck is idle. Select it and right-click a Supply dock, or left-click the dock with Trackpad controls on.":
    "کامیون تدارکات شما بیکار است. آن را انتخاب کنید و روی انبار منابع راست‌کلیک کنید، یا با «کنترل‌های ترک‌پد» روشن، روی انبار کلیک چپ کنید.",
  "Build {0} to train infantry and defend your base.":
    "برای آموزش پیاده‌نظام و دفاع از پایگاه، {0} بسازید.",
  "Open Infantry ({0}) and train soldiers. Select your squad and send it toward the enemy base.":
    "بخش «پیاده‌نظام» ({0}) را باز کنید و سرباز آموزش دهید. دستهٔ خود را انتخاب کنید و به‌سوی پایگاه دشمن بفرستید.",
  "Restore tips": "نمایش دوبارهٔ راهنمایی‌ها",
  "Training progress is saved when you win. Restart the mission anytime from Learn to play.":
    "پس از پیروزی، تکمیل آموزش ذخیره می‌شود. هر زمان می‌توانید از «آموزش بازی» مأموریت را دوباره شروع کنید.",
  "Training uses restart instead of match files. Your completion is remembered when you win.":
    "آموزش با شروع دوباره ادامه پیدا می‌کند و فایل ذخیرهٔ نبرد ندارد. پس از پیروزی، تکمیل آن به خاطر سپرده می‌شود.",
  "First Mission complete": "اولین مأموریت تکمیل شد",
  "You built a base, funded an army, and destroyed the enemy outpost. In a normal match, keep supplies flowing, defend your base, and destroy every enemy building.":
    "پایگاه ساختید، هزینهٔ ارتش را تأمین کردید و پاسگاه دشمن را نابود کردید. در نبرد عادی، جریان تدارکات را حفظ کنید، از پایگاه دفاع کنید و همهٔ ساختمان‌های دشمن را نابود کنید.",
  "Play a skirmish": "شروع نبرد تک‌نفره",
  "Play multiplayer": "بازی چندنفره",
  "Retry First Mission": "تلاش دوباره در اولین مأموریت",

  "Public rooms": "اتاق‌های عمومی",
  "Join public room": "ورود به اتاق عمومی",
  Join: "ورود",
  "{0}/{1} humans": "{0}/{1} بازیکن",
  "Starts in {0}s": "آغاز تا {0} ثانیه",
  "Queued for game capacity": "در صف ظرفیت بازی",
  "Public rooms unavailable. Private rooms remain available.":
    "اتاق‌های عمومی در دسترس نیستند. اتاق‌های خصوصی همچنان فعال هستند.",
  "Loading public rooms…": "بارگیری اتاق‌های عمومی…",
  "Room changed. Choose an available room.": "اتاق تغییر کرد. یک اتاق در دسترس انتخاب کنید.",
  "Ground too uneven": "زمین بیش از حد ناهموار است",
  "Terrain does not support construction": "این زمین برای ساخت‌وساز مناسب نیست",
  "Site occupied": "محل اشغال شده است",
  "Cannot build here · Site occupied": "ساخت ممکن نیست · محل اشغال شده است",
  "Cannot build here · Terrain does not support construction":
    "ساخت ممکن نیست · زمین برای ساخت‌وساز مناسب نیست",
  "Cannot build here · Ground too uneven": "ساخت ممکن نیست · زمین بیش از حد ناهموار است",
  Recommended: "پیشنهادشده",
  "Forested Highlands": "بلندی‌های جنگلی",
  "Forest ambushes · high ground": "کمین جنگلی · بلندی‌ها",
  "Crossings · supply raids": "گذرگاه‌ها · حمله به تدارکات",
  "Warehouse ambushes · service corridors": "کمین در انبارها · مسیرهای خدماتی",
  "Open flanks · exposed supplies": "جناح‌های باز · منابع بی‌حفاظ",
  "Marsh concealment · causeways": "استتار مردابی · گذرگاه‌ها",
  "Mountain passes · wooded flanks": "گردنه‌ها · جناح‌های جنگلی",
  "Sized for {0} players": "متناسب با {0} بازیکن",
  "Selected battlefield: {0}": "میدان انتخاب‌شده: {0}",
  "More map options": "گزینه‌های بیشتر نقشه",
  "Symmetric: matched approaches. Asymmetric: varied terrain and routes.":
    "متقارن: مسیرهای هم‌ارز. نامتقارن: زمین و مسیرهای متفاوت.",
  "This battlefield has one layout.": "این میدان یک چیدمان دارد.",
  Layout: "چیدمان",
  "River Lowlands": "دشت‌های رودخانه‌ای",
  "Ironworks Valley": "درهٔ آهنگری",
  "Redstone Badlands": "بدبوم‌های سرخ‌سنگ",
  "Tidal Marches": "تالاب‌های ساحلی",
  "Alpine Frontier": "مرز کوهستانی",
  Symmetric: "متقارن",
  Asymmetric: "نامتقارن",
  "{0} · {1} players · {2}": "{0} · {1} بازیکن · {2}",
  "River lowlands: several crossings, raised banks and vulnerable farm supply routes.":
    "دشت رودخانه‌ای: گذرگاه‌های متعدد، کرانه‌های بلند و مسیرهای تدارکات کشاورزی آسیب‌پذیر.",
  "Industrial valley: warehouse ambushes, rail corridors and elevated loading yards.":
    "دره صنعتی: کمین در انبارها، راهروهای راه‌آهن و محوطه‌های بارگیری مرتفع.",
  "Desert badlands: broad flanks, sandstone overlooks and exposed mining supplies.":
    "بدبوم بیابانی: جناح‌های باز، بلندی‌های ماسه‌سنگی و منابع معدنی بی‌حفاظ.",
  "Coastal wetlands: braided channels, concealed marsh trails and broad causeways.":
    "تالاب ساحلی: آبراه‌های شاخه‌دار، مسیرهای نهان مردابی و گذرگاه‌های پهن.",
  "Alpine frontier: terraced valleys, wooded approaches and several routes around high ground.":
    "مرز کوهستانی: دره‌های پلکانی، راه‌های جنگلی و مسیرهای متعدد پیرامون بلندی‌ها.",
  Crossfire: "کراس‌فایر",
  "Fallen Empire": "امپراتوری سقوط‌کرده",
  "4 players · Generals layout · center and flanks": "۴ بازیکن · چیدمان جنرالز · مرکز و جناح‌ها",
  "Fallen Empire: four corner bases, a low central basin and raised rear supplies. Fight through the center or raid along the flanks. For 2v2, ally the two north starts against the two south starts.":
    "امپراتوری سقوط‌کرده: چهار پایگاه در گوشه‌ها، یک حوضهٔ مرکزی کم‌ارتفاع و منابع پشتی در ارتفاع. از مرکز بجنگید یا از جناح‌ها به منابع حمله کنید. برای بازی دونفره در برابر دونفره، دو جایگاه شمالی را در برابر دو جایگاه جنوبی هم‌تیمی کنید.",
  "1v1 · expansion race · contested center": "تک‌به‌تک · مسابقهٔ توسعه‌طلبی · مرکز مورد مناقشه",
  "Crossfire: mirrored desert duel. Take the natural, choose a safe or open third, fight for the central derricks.":
    "کراس‌فایر: دوئل آینه‌ای بیابانی. پایگاه طبیعی را بگیرید، سهم سوم امن یا باز را انتخاب کنید و برای دکل‌های مرکزی بجنگید.",
  Commander: "فرمانده",
  "Commander for {0}": "فرمانده {0}",
  "Commander for seat {0}": "فرمانده جایگاه {0}",
  "Random commander": "فرمانده تصادفی",
  Raider: "یورشگر",
  Architect: "معمار",
  Breaker: "خط‌شکن",
  Orders: "فرمان‌ها",
  Mixed: "ترکیبی",
  Target: "هدف",
  "Issue order": "اجرای فرمان",
  "Queue order": "افزودن فرمان به صف",
  "Move together": "حرکت هماهنگ",
  "Custom formation": "آرایش سفارشی",
  "Save selection": "ذخیره انتخاب",

  On: "روشن",
  Off: "خاموش",
  "{0}-player highlands: outer flanks, forest trails, exposed supplies and a raised central relay.":
    "بلندی‌های {0} نفره: مسیرهای کناری، گذرگاه‌های جنگلی، منابع آسیب‌پذیر و رلهٔ مرکزی روی بلندی.",
  "Three Pines": "سه کاج",
  "Fourwater Highlands": "بلندی‌های چهارآب",
  "Five Ridges": "پنج یال",
  "Timberline Basin": "حوضهٔ جنگلی",
  "Crown of Pines": "تاج کاج‌ها",
  "Great Highland Divide": "آب‌پخشان بزرگ",
  "Forested highlands study: elevated sawmill, infantry trails and several approaches.":
    "بررسی بلندی‌های جنگلی: چوب‌بری مرتفع، مسیرهای پیاده‌نظام و چند راه دسترسی.",

  Movement: "حرکت",
  "Movement mode": "حالت حرکت",
  Together: "با هم",
  Custom: "سفارشی",
  More: "بیشتر",
  "Guard target": "هدف نگهبانی",
  "Advanced unit controls": "فرمان‌های پیشرفتهٔ یگان",
  Hold: "حفظ موضع",
  Area: "منطقه",
  "Free moves independently. Together protects rear units and matches the slowest member. Applies to the next order.":
    "آزاد مستقل حرکت می‌کند. با هم از یگان‌های عقب محافظت می‌کند و سرعت را با کندترین عضو هماهنگ می‌کند. برای فرمان بعدی اعمال می‌شود.",
  "Guard ground or an owned building; escort an owned unit. {0}":
    "از زمین یا ساختمان خودی نگهبانی کنید؛ یگان خودی را اسکورت کنید. {0}",
  "Choose ground, an owned building or an owned unit to guard. {0} cancels; {1} queues.":
    "زمین، ساختمان خودی یا یگان خودی را برای نگهبانی انتخاب کنید. {0} لغو می‌کند؛ {1} به صف اضافه می‌کند.",
  "Right-drag sets facing; {0} changes shape when the build flyout is closed. The wheel adjusts spacing during placement. {1} queues orders.":
    "با کشیدن راست‌کلیک جهت را تعیین کنید؛ وقتی فهرست ساخت بسته است، {0} شکل آرایش را تغییر می‌دهد. چرخ ماوس فاصله را تغییر می‌دهد. {1} فرمان‌ها را در صف قرار می‌دهد.",
  "Guard, then click ground, an owned building or an owned unit. Guard and Escort use normal pursuit range. More offers Follow and keyboard targeting while armed. {0} queues orders.":
    "نگهبانی را بزنید، سپس روی زمین، ساختمان خودی یا یگان خودی کلیک کنید. نگهبانی و همراهی از برد تعقیب عادی استفاده می‌کنند. بخش بیشتر، دنبال‌کردن و هنگام هدف‌گیری، ورود هدف با صفحه‌کلید را ارائه می‌دهد. {0} فرمان را به صف اضافه می‌کند.",
  "Groups remember units and names only. One movement setting applies across selections. Groups and movement settings reset on a new match, load, reload or full rejoin. Transient reconnect retains them.":
    "گروه‌ها فقط یگان‌ها و نام‌ها را حفظ می‌کنند. یک حالت حرکت برای همهٔ انتخاب‌ها اعمال می‌شود. گروه‌ها و حالت حرکت با بازی جدید، بارگذاری، بارگذاری دوبارهٔ صفحه یا پیوستن کامل بازنشانی می‌شوند. اتصال دوبارهٔ موقت آن‌ها را حفظ می‌کند.",

  "Trackpad controls": "کنترل‌های ترک‌پد",
  "CLICK CONTROLS": "کنترل با کلیک",
  "Select rectangle": "انتخاب مستطیلی",
  "Visible army": "ارتش در دید",
  "Select matching units": "انتخاب یگان‌های هم‌نوع",
  "Trackpad shortcuts": "میان‌برهای ترک‌پد",
  "Show click controls beside the build column. Keyboard shortcuts always work.":
    "کنترل‌های کلیکی را کنار ستون ساخت نمایش دهید. میان‌برهای صفحه‌کلید همیشه کار می‌کنند.",
  "{0} ({1})": "{0} ({1})",
  "{0} shortcut": "میان‌بر {0}",
  "Click opposite corner · {0} adds · {1} cancels":
    "گوشهٔ مقابل را کلیک کنید · {0} برای افزودن · {1} برای لغو",
  "Click first corner · {0} cancels": "گوشهٔ اول را کلیک کنید · {0} برای لغو",
  "Click two opposite corners to select units. {0} adds to selection.":
    "برای انتخاب یگان‌ها دو گوشهٔ مقابل را کلیک کنید. {0} به انتخاب می‌افزاید.",
  "Select your combat units in view. {0} adds to selection.":
    "یگان‌های رزمی خود را در دید انتخاب کنید. {0} به انتخاب می‌افزاید.",
  "Select your visible units matching the selected types. {0} adds to selection.":
    "یگان‌های در دید و هم‌نوع با انتخاب فعلی را انتخاب کنید. {0} به انتخاب می‌افزاید.",
  "Left click gives orders. Select rectangles with two clicks. {0} queues orders or adds units. {1} clears the selection.":
    "کلیک چپ فرمان می‌دهد. با دو کلیک مستطیل انتخاب بسازید. {0} فرمان‌ها را به صف یا یگان‌ها را به انتخاب می‌افزاید. {1} انتخاب را پاک می‌کند.",
  "Left click gives orders. {0} clears the selection.":
    "کلیک چپ فرمان می‌دهد. {0} انتخاب را پاک می‌کند.",
  "{0} cancels targeting. Existing mouse controls still work.":
    "{0} هدف‌گیری را لغو می‌کند. کنترل‌های معمول ماوس همچنان کار می‌کنند.",
  "Two-click selection": "انتخاب با دو کلیک",
  "Click orders": "فرمان با کلیک",
  "Selection shortcuts": "میان‌برهای انتخاب",
  "Trackpad keys": "کلیدهای ترک‌پد",
  "{0} or Select rectangle, then click opposite corners; {1} adds units":
    "{0} یا انتخاب مستطیلی، سپس کلیک روی گوشه‌های مقابل؛ {1} یگان‌ها را اضافه می‌کند",
  "Left click a target with units selected to give orders; {0} queues":
    "با انتخاب یگان‌ها روی هدف کلیک چپ کنید تا فرمان داده شود؛ {0} به صف می‌افزاید",
  "{0} selects visible combat units; {1} selects visible units of the selected types":
    "{0} یگان‌های رزمی در دید را انتخاب می‌کند؛ {1} یگان‌های هم‌نوع با انتخاب فعلی را در دید انتخاب می‌کند",
  "Remap the default {0} / {1} / {2} shortcuts in Settings or the pause menu":
    "میان‌برهای پیش‌فرض {0} / {1} / {2} را در تنظیمات یا منوی توقف تغییر دهید",
  "Select the free Supply truck, then right-click a Supply dock to gather (left-click with Trackpad controls on).":
    "کامیون تدارکات رایگان را انتخاب کنید و برای جمع‌آوری روی انبار منابع راست‌کلیک کنید (با «کنترل‌های ترک‌پد» روشن، کلیک چپ).",
  Attack: "حمله",
  Selection: "انتخاب",
  "Close commands": "بستن فرمان‌ها",
  "Touch device": "دستگاه لمسی",
  "Mouse and keyboard": "ماوس و صفحه‌کلید",
  "Touch controls": "کنترل لمسی",
  "Install Razmak": "نصب رزمک",
  "Tap your unit to select. Tap ground or an enemy to order. Drag to move the camera.":
    "برای انتخاب، یگان خود را لمس کنید. برای فرمان دادن، زمین یا دشمن را لمس کنید. برای جابه‌جایی دوربین، انگشت را بکشید.",
  "Hold then drag to select a group. Double-tap a unit to select its type on screen. Pinch to zoom; twist to rotate.":
    "برای انتخاب گروهی، لمس را نگه دارید و بکشید. با دو بار لمس یک یگان، همهٔ یگان‌های هم‌نوع روی صفحه انتخاب می‌شوند. با دو انگشت بزرگ‌نمایی کنید یا دوربین را بچرخانید.",
  "Queue keeps later orders. Turn Queue off before the last patrol point. Deselect also cancels targeting.":
    "صف فرمان‌ها، فرمان‌های بعدی را نگه می‌دارد. پیش از انتخاب آخرین نقطهٔ گشت، صف را غیرفعال کنید. لغو انتخاب، هدف‌گیری را هم لغو می‌کند.",
  "Hold a command to read its tooltip. Tap elsewhere to close it. Tap the map to move the camera.":
    "برای خواندن راهنمای فرمان، لمس را نگه دارید. برای بستن راهنما، جای دیگری را لمس کنید. با لمس نقشه، دوربین جابه‌جا می‌شود.",
  "On a phone, Commands opens the build panel. Close it or choose a building to return to the battlefield.":
    "در گوشی، دکمهٔ فرمان‌ها پنل ساخت را باز می‌کند. برای بازگشت به میدان نبرد، آن را ببندید یا یک ساختمان را انتخاب کنید.",
  "Use Install app in your browser menu, or Share then Add to Home Screen on iPhone and iPad. Internet is required for online matches.":
    "از گزینهٔ نصب برنامه در منوی مرورگر استفاده کنید. در آیفون و آیپد، از منوی اشتراک‌گذاری گزینهٔ افزودن به صفحهٔ اصلی را بزنید. نبرد آنلاین به اینترنت نیاز دارد.",
  "Touch orders": "فرمان‌های لمسی",
  "Queue orders on": "صف فرمان‌ها فعال است",
  "Queue orders off": "صف فرمان‌ها غیرفعال است",
  Deselect: "لغو انتخاب",
  "Rotate your device": "دستگاه را افقی کنید",
  "Play in landscape for room to command your army.":
    "برای فرماندهی بهتر، دستگاه را افقی نگه دارید.",
  "Online matches continue while this message is shown.":
    "نبرد آنلاین هنگام نمایش این پیام ادامه دارد.",
  "Faction for {0}": "جناح {0}",
  "Cruise missile": "موشک کروز",
  Missile: "موشک",
  "Waiting · Population cap": "انتظار · سقف جمعیت",
  "Waiting · Exit blocked": "انتظار · مسیر خروج مسدود است",
  "Current selection": "انتخاب فعلی",
  "Formation rejected ({0}).": "آرایش پذیرفته نشد ({0}).",
  "Group {0}{1}": "گروه {0}{1}",
  "Protected rear": "عقب محافظت‌شده",
  Deploying: "در حال استقرار",
  Undeploying: "در حال جمع‌کردن تجهیزات",
  Deployed: "مستقر",
  Mobile: "متحرک",
  "Command unavailable": "فرمان در دسترس نیست",
  "Strike center unavailable": "مرکز موشکی در دسترس نیست",
  "Missile strike unavailable": "حملهٔ موشکی در دسترس نیست",
  "Target outside the map": "هدف بیرون نقشه است",
  "Low power · missile preparation paused": "کمبود برق · آماده‌سازی موشک متوقف است",
  "Purchase a missile first": "ابتدا یک موشک بخرید",
  "Missile ready in {0}s": "موشک تا {0} ثانیهٔ دیگر آماده می‌شود",
  "Strike center under construction": "مرکز موشکی در حال ساخت است",
  "Requires a completed Strike center": "به مرکز موشکی کامل نیاز دارد",
  "Game over": "بازی تمام شده است",
  "Owner eliminated": "بازیکن حذف شده است",
  "Enter {0} from {1} to {2}.": "مقدار {0} را بین {1} و {2} وارد کنید.",
  "Settings request failed.": "درخواست تنظیمات ناموفق بود.",
  "RAZMAK / ADMINISTRATION": "رزمک / مدیریت",
  "Game settings": "تنظیمات بازی",
  "Enter the dedicated administrator token.": "توکن اختصاصی مدیر را وارد کنید.",
  "Administrator token": "توکن مدیر",
  "Authorizing…": "در حال احراز هویت…",
  "Open settings": "بازکردن تنظیمات",
  "Return to the game": "بازگشت به بازی",
  "Saved revision {0}. New games use these settings.":
    "نسخهٔ {0} ذخیره شد. بازی‌های جدید از این تنظیمات استفاده می‌کنند.",
  "Loaded the latest revision. Your edits remain in the draft. Review the comparison before applying.":
    "آخرین نسخه دریافت شد. ویرایش‌های شما در پیش‌نویس باقی مانده‌اند. پیش از اعمال، تفاوت‌ها را بررسی کنید.",
  "Revision ": "نسخهٔ ",
  " · Defaults ": " · پیش‌فرض‌ها ",
  " · Schema": " · ساختار",
  "Log out": "خروج از حساب",
  " changed fields": " فیلد تغییرکرده",
  "Reset all defaults": "بازنشانی همهٔ پیش‌فرض‌ها",
  "Discard edits": "حذف ویرایش‌ها",
  "Saving…": "در حال ذخیره…",
  "Apply to new games": "اعمال بر بازی‌های جدید",
  "Active games retain their settings. Saved games and battle records retain their embedded settings.":
    "تنظیمات بازی‌های فعال تغییر نمی‌کند. بازی‌های ذخیره‌شده و بازپخش‌ها تنظیمات داخلی خود را حفظ می‌کنند.",
  "Load latest revision and retain my edits": "دریافت آخرین نسخه با حفظ ویرایش‌های من",
  "Review pending changes": "بررسی تغییرات در انتظار",
  "Review changes": "بررسی تغییرات",
  "All base values and multipliers will use their defaults.":
    "همهٔ مقادیر پایه و ضرایب به پیش‌فرض بازمی‌گردند.",
  "Apply this draft only after you review each changed value.":
    "تنها پس از بررسی تک‌تک مقادیر تغییرکرده، این پیش‌نویس را اعمال کنید.",
  " · Effective {0} → {1}": " · مؤثر {0} ← {1}",
  " · Default": " · پیش‌فرض",
  "Search settings": "جست‌وجوی تنظیمات",
  "Show overridden values": "نمایش مقادیر تغییریافته",
  " fields": " فیلد",
  "Default ": "پیش‌فرض ",
  " · Overridden": " · تغییریافته",
  " · Effective {0}": " · مؤثر {0}",
  "Reset {0} to default": "بازنشانی {0} به پیش‌فرض",
  "Reset to default": "بازنشانی به پیش‌فرض",
  "No settings match your filters.": "هیچ تنظیمی با فیلترهای شما مطابقت ندارد.",
  "Revision history": "تاریخچهٔ نسخه‌ها",
  "No changes have been saved.": "هنوز تغییری ذخیره نشده است.",
  " · Defaults": " · پیش‌فرض‌ها",
  Aqua: "فیروزه‌ای",
  Pink: "صورتی",
  Mint: "نعنایی",
  Neutral: "بی‌طرف",
  "Team {0}": "تیم {0}",
  "HTTP {0}": "خطای HTTP {0}",
  "Cannot load the model textures. Reload to retry.":
    "بافت مدل‌ها بارگیری نشد. برای تلاش مجدد صفحه را بازآوری کنید.",
  "Order applied.": "فرمان اعمال شد.",
  "Order rejected ({0}).": "فرمان پذیرفته نشد ({0}).",
  "Choose an area anchor. {0} cancels; {1} queues.":
    "نقطهٔ نگهبانی را انتخاب کنید. {0} لغو می‌کند؛ {1} فرمان را در صف می‌گذارد.",
  "Choose a living owned target. {0} cancels; {1} queues.":
    "یک هدف زنده از نیروهای خود انتخاب کنید. {0} لغو می‌کند؛ {1} فرمان را در صف می‌گذارد.",
  "Choose a living owned target of the requested kind.":
    "یک هدف زنده از نوع خواسته‌شده و متعلق به خود انتخاب کنید.",
  "Order pending authority.": "فرمان در انتظار تأیید سرور است.",
  "{0} · Wheel spacing · {1} shape · {2} queues · {3} cancels":
    "{0} · چرخ ماوس: فاصله · {1}: شکل · {2}: صف · {3}: لغو",
  "{0} new walls · {1} credits · Click endpoint":
    "{0} دیوار جدید · {1} اعتبار · نقطهٔ پایان را انتخاب کنید",
  "Click to build · Shift to queue": "برای ساخت کلیک کنید · Shift برای صف",
  Close: "بستن",
  "Razmak needs WebGL 2. Enable it in your browser or update to a device that supports it.":
    "رزمک به WebGL 2 نیاز دارد. آن را در مرورگر فعال کنید یا از دستگاه سازگار استفاده کنید.",
  "Dismiss WebGL 2 requirement notice": "بستن پیام نیاز به WebGL 2",
  "The 3D view failed to start. Reload to try again.":
    "نمای سه‌بعدی اجرا نشد. صفحه را بازآوری کنید.",
  "Dismiss 3D start failure notice": "بستن پیام خطای اجرای نمای سه‌بعدی",
  "3D display was lost. Reload the page to keep playing.":
    "نمایش سه‌بعدی قطع شد. برای ادامهٔ بازی صفحه را بازآوری کنید.",
  "Dismiss 3D display notice": "بستن پیام قطع نمایش سه‌بعدی",
  Reload: "بازآوری",
  "Reload the page": "بازآوری صفحه",
  DEPLOYING: "در حال استقرار",
  UNDEPLOYING: "در حال جمع‌کردن تجهیزات",
  DEPLOYED: "مستقر",
  "+{0} Money": "+{0} اعتبار",
  "OFFLINE · LOW POWER": "غیرفعال · کمبود برق",
  "Patrol ↻ · {0} points · {1} queued": "گشت ↻ · {0} نقطه · {1} فرمان در صف",
  "MISSILE STRIKE · {0}s": "حملهٔ موشکی · {0} ثانیه",
  "CRUISE MISSILE · {0}s": "حملهٔ موشک کروز · {0} ثانیه",
  "Cruise missile · radius {0}": "موشک کروز · شعاع {0}",
  "Patrol: click to finish, {2}+click to add a point ({0}/{1}), {3} to cancel":
    "گشت: کلیک برای پایان، {2}+کلیک برای افزودن نقطه ({0}/{1})، {3} برای لغو",
  "Select an available battlefield for a new match.":
    "برای بازی جدید یک میدان نبرد موجود انتخاب کنید.",
  "Cannot save: unknown side.": "ذخیره ممکن نیست: جناح نامشخص است.",
  "Cannot save a multiplayer match. Save a single-player battle, or download the battle record after the match ends.":
    "بازی چندنفره را نمی‌توان ذخیره کرد. نبرد تک‌نفره را ذخیره کنید یا پس از پایان بازی، بازپخش را بگیرید.",
  "Could not save this battle ({0}). The battle still plays.":
    "ذخیرهٔ این نبرد ممکن نشد ({0}). نبرد همچنان ادامه دارد.",
  "Cannot save: this battle ({0}) is larger than the {1} limit. The battle still plays.":
    "ذخیره ممکن نیست: حجم این نبرد ({0}) از محدودیت {1} بیشتر است. نبرد همچنان ادامه دارد.",
  "That saved-match file is too large ({0}; limit {1}). The current battle is untouched.":
    "حجم فایل ذخیره‌شده بیش از حد است ({0}؛ محدودیت {1}). نبرد فعلی تغییر نکرده است.",
  "That file is not a saved match. Pick a Razmak saved-match file.":
    "این فایل، بازی ذخیره‌شده نیست. یک فایل ذخیرهٔ رزمک انتخاب کنید.",
  "That saved match is version {0}; this game reads version {1}.":
    "نسخهٔ این ذخیره {0} است؛ بازی نسخهٔ {1} را می‌خواند.",
  "That saved match names no valid difficulty.": "این ذخیره سطح دشواری معتبری ندارد.",
  "That saved match has no battle in it.": "این فایل ذخیره، نبردی ندارد.",
  "That saved match is damaged ({0}). The current battle is untouched.":
    "فایل ذخیره خراب است ({0}). نبرد فعلی تغییر نکرده است.",
  "Cannot save: this record ({0}) is larger than the {1} limit. The battle still plays.":
    "ذخیره ممکن نیست: حجم بازپخش ({0}) از محدودیت {1} بیشتر است. نبرد همچنان ادامه دارد.",
  "That battle-record file is too large ({0}; limit {1}). The current battle is untouched.":
    "حجم فایل بازپخش بیش از حد است ({0}؛ محدودیت {1}). نبرد فعلی تغییر نکرده است.",
  "That file is not a battle record. Pick a Razmak battle-record file.":
    "این فایل بازپخش نیست. یک فایل بازپخش رزمک انتخاب کنید.",
  "That battle record is damaged ({0}). The current battle is untouched.":
    "فایل بازپخش خراب است ({0}). نبرد فعلی تغییر نکرده است.",
  "Cannot export a battle record before the multiplayer match ends. The battle still plays.":
    "پیش از پایان بازی چندنفره نمی‌توان بازپخش را دریافت کرد. نبرد همچنان ادامه دارد.",
  "The finished battle record is not ready yet. Try again in a moment.":
    "بازپخش نبرد تمام‌شده هنوز آماده نیست. کمی بعد دوباره تلاش کنید.",
  "Battle record unavailable: {0}. The battle still plays.":
    "بازپخش در دسترس نیست: {0}. نبرد همچنان ادامه دارد.",
  "No battle record yet. Records start when a battle starts.":
    "هنوز بازپخشی نیست. ضبط با شروع نبرد آغاز می‌شود.",
  "Battle record unavailable: {0}": "بازپخش در دسترس نیست: {0}",
  "Battle record ready to save.": "بازپخش برای ذخیره آماده است.",
  "Recording this battle…": "در حال ضبط این نبرد…",
  "No battle record.": "بازپخشی موجود نیست.",
  "Saved match loaded. Battle record unavailable: {0}":
    "بازی ذخیره‌شده بارگیری شد. بازپخش در دسترس نیست: {0}",
  "Invalid replay: {0}.": "بازپخش نامعتبر است: {0}.",
  "Record damaged: {0} The frozen moment stays on view.":
    "بازپخش خراب است: {0} تصویر در همان لحظه باقی می‌ماند.",
  "Record ended — the final moment stays on view. Exit to return.":
    "بازپخش تمام شد؛ تصویر پایانی باقی می‌ماند. برای بازگشت خارج شوید.",
  "Watching battle record · {0} / {1}. Orders are locked while watching.":
    "تماشای بازپخش · {0} / {1}. هنگام تماشا صدور فرمان ممکن نیست.",
  "Missile preparation command rejected": "فرمان آماده‌سازی موشک پذیرفته نشد",
  "Production command rejected": "فرمان تولید پذیرفته نشد",
  "Command rejected": "فرمان پذیرفته نشد",
  "Production cancel rejected": "لغو تولید پذیرفته نشد",
  "Recovery order pending.": "فرمان بازیابی در انتظار است.",
  "Catch-up · {0} s": "جبران عقب‌ماندگی · {0} ثانیه",
  "Dock throughput +{0}%; unit production time -{1}%.":
    "بازده بارگیری {0}٪ بیشتر و زمان تولید واحد {1}٪ کمتر است.",
  "Emergency recovery": "بازیابی اضطراری",
  Recovery: "بازیابی",
  "Claim recovery": "دریافت کمک بازیابی",
  "The game host is missing.": "عنصر میزبان بازی موجود نیست.",
  "Replace with selection": "جایگزینی با انتخاب فعلی",
  "{0}+#": "{0}+#",
  "Add selection": "افزودن انتخاب فعلی",
  "{0}+{1}+#": "{0}+{1}+#",
  "Remove selection": "حذف انتخاب فعلی",
  "Steal selection": "انتقال انتخاب از گروه‌های دیگر",
  "Clear group": "پاک‌کردن گروه",
  "Control groups": "گروه‌های کنترل",
  GROUPS: "گروه‌ها",
  "Under attack": "مورد حمله",
  "Save the current selection as a new group ({0}+number)":
    "ذخیرهٔ انتخاب فعلی در گروه جدید ({0}+عدد)",
  "+ Group": "+ گروه",
  "Group {0}": "گروه {0}",
  "Group ": "گروه ",
  "Select ": "انتخاب ",
  "Add group to selection ": "افزودن گروه به انتخاب ",
  "Shift+": "Shift+",
  "Center camera": "تمرکز دوربین",
  "Add selected members here and remove them from other groups. Orders keep running.":
    "اعضای انتخاب‌شده را اینجا اضافه و از گروه‌های دیگر حذف کنید. فرمان‌های فعلی ادامه می‌یابند.",
  "Group name": "نام گروه",
  "Name this group": "برای این گروه نام بگذارید",
  Rename: "تغییر نام",
  "Gathering from Supply dock · {0} supplies": "برداشت از انبار منابع · {0} منابع",
  "Constructing / repairing": "ساخت / تعمیر",
  Moving: "در حال حرکت",
  "Patrolling · Point {0}/{1}": "در حال گشت · نقطهٔ {0}/{1}",
  "Attack-move": "حرکت تهاجمی",
  Attacking: "در حال حمله",
  "Constructing {0}%{1}": "در حال ساخت {0}%{1}",
  "OFFLINE · Low power": "غیرفعال · کمبود برق",
  "Training {0} · {1}": "در حال تولید {0} · {1}",
  "Low power": "کمبود برق",
  "Upgrading {0} · {1}%": "در حال ارتقای {0} · {1}%",
  "Empty · Purchase a missile": "خالی · یک موشک بخرید",
  "Empty · Purchase a cruise missile": "خالی · یک موشک کروز بخرید",
  "Missile ready · Awaiting launch": "موشک آماده است · انتظار برای پرتاب",
  "Cruise missile ready · Awaiting launch": "موشک کروز آماده است · انتظار برای پرتاب",
  "Preparing missile · {0}% · {1}s{2}": "آماده‌سازی موشک · {0}% · {1} ثانیه{2}",
  "Preparing cruise missile · {0}% · {1}s{2}": "آماده‌سازی موشک کروز · {0}% · {1} ثانیه{2}",
  " · Mission slots {0}/{1}": " · جایگاه مأموریت {0}/{1}",
  "Cancel last {0} of {1} queued, entry {2}": "لغو آخرین {0} از {1} در صف، ردیف {2}",
  "Supplies unknown": "مقدار منابع نامشخص است",
  "Out of sight — move a unit closer to inspect": "خارج از دید؛ برای بررسی یک یگان را نزدیک‌تر کنید",
  "Supplies exhausted (last seen)": "منابع تمام شده‌اند (آخرین مشاهده)",
  "Exhausted when last seen — move a unit closer for an update":
    "در آخرین مشاهده خالی بود؛ برای به‌روزرسانی یک یگان را نزدیک‌تر کنید",
  "Supplies {0} (last seen)": "منابع {0} (آخرین مشاهده)",
  "Last seen — move a unit closer for an update":
    "آخرین مشاهده؛ برای به‌روزرسانی یک یگان را نزدیک‌تر کنید",
  "Supplies exhausted": "منابع تمام شده‌اند",
  "Exhausted — move supply trucks to another dock with supplies":
    "منابع تمام شده‌اند؛ کامیون‌ها را به انبار دیگری با منابع ببرید",
  "Supplies {0}": "منابع {0}",
  "Regrowing +{0}/s to {1} — haul normally":
    "بازسازی +{0} در ثانیه تا سقف {1}؛ برداشت را ادامه دهید",
  "Trucks {0}/{1} at full rate": "کامیون‌ها {0}/{1} با بازده کامل",
  "Trucks {0}/{1} — crowded, each load is {2}%": "کامیون‌ها {0}/{1}؛ شلوغ است، هر بار {2}٪",
  Stance: "حالت رزمی",
  "{0} eligible, {1} excluded. Armed owned units only; unavailable units are excluded.":
    "{0} واجد شرایط، {1} مستثنا. فقط یگان‌های مسلح خودی؛ یگان‌های ناموجود مستثنا هستند.",
  "Stance order pending.": "فرمان حالت رزمی در انتظار تأیید است.",
  "Stance applied.": "حالت رزمی اعمال شد.",
  "Stance rejected ({0}).": "حالت رزمی پذیرفته نشد ({0}).",
  "Fire policy": "سیاست آتش",
  "Fire policy order pending.": "فرمان سیاست آتش در انتظار تأیید است.",
  "Start game": "شروع بازی",
  "Pause menu": "منوی توقف",
  "Save match": "ذخیرهٔ بازی",
  "Save battle record": "ذخیرهٔ بازپخش",
  "Game result": "نتیجهٔ بازی",
  "Match status": "وضعیت نبرد",
  "Open menu, {0}": "بازکردن منو، {0}",
  "Menu ": "منو ",
  Esc: "Esc",
  Players: "بازیکنان",
  "Connection quality unknown": "کیفیت اتصال نامشخص است",
  "Game time": "زمان بازی",
  "Elapsed ": "زمان سپری‌شده ",
  "Worst remote link": "کندترین اتصال بازیکنان",
  "Economy and units": "اقتصاد و یگان‌ها",
  "Loot received": "غنیمت دریافتی",
  "Viewing owner": "بازیکن در حال مشاهده",
  POWER: "برق",
  LIVE: "زنده",
  UNITS: "یگان‌ها",
  "Idle builders ({0})": "سازندگان بیکار ({0})",
  "Please wait before sending again.": "پیش از ارسال دوباره کمی صبر کنید.",
  "This channel is not available now.": "این کانال اکنون در دسترس نیست.",
  "Message rejected. Check the message and channel.":
    "پیام پذیرفته نشد. پیام و کانال را بررسی کنید.",
  "Please wait before sending another ping.": "پیش از ارسال نشان بعدی کمی صبر کنید.",
  "Ping unavailable.": "نشان نقشه در دسترس نیست.",
  "Enter a message up to 280 characters.": "پیامی با حداکثر 280 نویسه وارد کنید.",
  "Take a seat to chat.": "برای گفت‌وگو یک جایگاه بگیرید.",
  "Type a message first.": "ابتدا یک پیام بنویسید.",
  "Chat is unavailable.": "گفت‌وگو در دسترس نیست.",
  Chat: "گفت‌وگو",
  "Ping wheel": "منوی نشان نقشه",
  "Open chat": "بازکردن گفت‌وگو",
  "Chat · {0}": "گفت‌وگو · {0}",
  Lobby: "اتاق",
  Team: "تیم",
  All: "همه",
  " ping": " نشان نقشه",
  Unmute: "لغو بی‌صداکردن",
  Mute: "بی‌صداکردن",
  "Chat channel": "کانال گفت‌وگو",
  "Chat message": "پیام گفت‌وگو",
  Send: "ارسال",
  "Close chat": "بستن گفت‌وگو",
  "Ground pickup · {0} Money": "برداشت زمینی · {0} اعتبار",
  "Engineer capture · Income after {0} seconds": "تصرف با مهندس · درآمد پس از {0} ثانیه",
  Damage: "آسیب",
  Radius: "شعاع",
  Range: "برد",
  Preparation: "آماده‌سازی",
  "Air targets": "اهداف هوایی",
  "Ground + air targets": "اهداف زمینی و هوایی",
  "Ground targets": "اهداف زمینی",
  "Splash {0}": "آسیب منطقه‌ای {0}",
  Power: "برق",
  Income: "درآمد",
  "On completion": "پس از تکمیل",
  "Trains {0}": "تولید {0}",
  "Trains {0} unit types": "تولید {0} نوع یگان",
  "Includes 1 {0}": "شامل 1 {0}",
  Upgradable: "قابل ارتقا",
  "Missile strike": "حملهٔ موشکی",
  "Cruise missile strike": "حملهٔ موشک کروز",
  Transportable: "قابل حمل",
  Airborne: "هوابرد",
  Seats: "صندلی",
  Cargo: "بار",
  Healing: "درمان",
  Repair: "تعمیر",
  "Paid repairs": "تعمیر با هزینه",
  "Consumed on capture": "مصرف‌شونده هنگام تصرف",
  "Deploy to fire": "برای شلیک مستقر شود",
  Deployable: "قابل استقرار",
  "Manual attack": "حملهٔ دستی",
  "Consumed on impact": "مصرف‌شونده هنگام برخورد",
  "Limit {0}": "محدودیت {0}",
  "Damage ": "آسیب ",
  "Range ": "برد ",
  "Splash ": "آسیب منطقه‌ای ",
  "Income ": "درآمد ",
  "Infantry ·": "پیاده‌نظام ·",
  "Armor: {0}": "زره: {0}",
  "Damage per shot, before target armor modifiers": "آسیب هر شلیک، پیش از اثر زره هدف",
  "Income requires completion; low power reduces it to 25%":
    "درآمد پس از تکمیل برقرار است؛ کمبود برق آن را به ۲۵٪ کاهش می‌دهد",
  "Damage {0} / shot · {1}s reload": "آسیب {0} / شلیک · بارگذاری {1} ثانیه",
  "Range {0}{1} · {2}": "برد {0}{1} · {2}",
  "Splash radius {0}": "شعاع آسیب منطقه‌ای {0}",
  "Aircraft damage ×{0}": "آسیب به هواگرد ×{0}",
  "Sight {0}{1}": "دید {0}{1}",
  "Generates {0} power": "تولید {0} برق",
  "Consumes {0} power": "مصرف {0} برق",
  "Income +{0} / s; 25% under low power": "درآمد +{0} در ثانیه؛ ۲۵٪ با کمبود برق",
  "Produces: {0}": "تولید می‌کند: {0}",
  "Free {0} on completion, when capacity and exit allow":
    "یک {0} رایگان پس از تکمیل، در صورت وجود ظرفیت و خروجی",
  "Receives supplies from supply trucks": "دریافت منابع از کامیون‌های تدارکات",
  "Upgrades: {0}": "ارتقاها: {0}",
  "Missile strike: {0} damage · {1} radius": "حملهٔ موشکی: {0} آسیب · شعاع {1}",
  "Cruise missile strike: {0} damage · {1} radius": "حملهٔ موشک کروز: {0} آسیب · شعاع {1}",
  "Preparation {0}s · Missile speed {1} / s": "آماده‌سازی {0} ثانیه · سرعت موشک {1} / ثانیه",
  "Consumes 0 power": "بدون مصرف برق",
  "Airborne · Ignores terrain and walls": "هوابرد · عبور از زمین و دیوار",
  "Infantry · Can be healed and transported": "پیاده‌نظام · قابل درمان و حمل",
  "Carries {0} infantry": "حمل {0} پیاده‌نظام",
  "Heals {0} HP / s · Range {1} · Free": "درمان {0} سلامت در ثانیه · برد {1} · رایگان",
  "Builds and repairs buildings · Repair {0} HP / s · Costs money":
    "ساخت و تعمیر ساختمان · تعمیر {0} سلامت در ثانیه · با هزینه",
  "Cargo {0} supplies · Loads in {1}s": "بار {0} منابع · بارگیری در {1} ثانیه",
  "Captures enemy buildings · Consumed on capture · Excludes HQ and walls":
    "تصرف ساختمان دشمن · مهندس مصرف می‌شود · به‌جز مقر فرماندهی و دیوار",
  "Deploys in {0}s{1}": "استقرار در {0} ثانیه{1}",
  "Manual attack · Consumed on impact": "حملهٔ دستی · مصرف‌شونده هنگام برخورد",
  "Limit {0} per owner{1}": "محدودیت {0} برای هر بازیکن{1}",
  "Sell building": "فروش ساختمان",
  Stop: "ایست",
  "Rally point": "نقطهٔ تجمع",
  Patrol: "گشت",
  Unload: "پیاده‌کردن",
  "Blocks ground movement. Enemies must explicitly attack it. Does not count for victory.":
    "مانع حرکت زمینی است. دشمن باید صریحاً به آن حمله کند. برای پیروزی به حساب نمی‌آید.",
  "Releases infantry passengers next to selected transports.":
    "مسافران پیاده را کنار نفربرهای انتخاب‌شده پیاده می‌کند.",
  "Right-click an owned transport with infantry to enter; {0} unloads transports":
    "برای سوارشدن، با پیاده‌نظام روی نفربر خودی راست‌کلیک کنید؛ {0} سرنشینان را پیاده می‌کند.",
  "Fly over terrain and walls. Only anti-air weapons can attack them; transports cannot service them":
    "از زمین و دیوار عبور می‌کنند. فقط سلاح ضدهوایی به آن‌ها آسیب می‌زند؛ نفربر نمی‌تواند به آن‌ها خدمت دهد",
  "Repair bay services vehicles only": "تعمیرگاه فقط به خودروها خدمات می‌دهد",
  "Unload {0} passengers": "پیاده‌کردن {0} مسافر",
  "Embarked infantry cannot fight or provide its own sight. A destroyed transport can lose passengers.":
    "پیاده‌نظام سوارشده نه می‌تواند بجنگد و نه دید خود را دارد. نابودی نفربر می‌تواند سرنشینان را از دست بدهد.",
  "Infantry · Can be transported": "پیاده‌نظام · قابل حمل",
  Upgrade: "ارتقا",
  "Deploy / Undeploy": "استقرار / جمع‌کردن",
  "Adds {0} power supply": "افزودن {0} تولید برق",
  "Adds {0} power use": "افزودن {0} مصرف برق",
  "Damage {0} / shot · Range {1} · {2}s reload · {3}":
    "آسیب {0} / شلیک · برد {1} · بارگذاری {2} ثانیه · {3}",
  "Refund: {0}%": "بازپرداخت: {0}%",
  "Requires:": "نیازمندی‌ها:",
  "Requires: {0}": "نیازمندی‌ها: {0}",
  "Infantry / drone defense": "دفاع در برابر پیاده‌نظام / پهپاد",
  "Anti-armor infantry": "پیاده‌نظام ضدزره",
  "Area-damage infantry": "پیاده‌نظام با آسیب منطقه‌ای",
  "Durable anti-infantry": "ضدپیاده‌نظام مقاوم",
  "Elite area-damage infantry": "پیاده‌نظام نخبه با آسیب منطقه‌ای",
  "Anti-infantry vehicle": "خودروی ضدپیاده‌نظام",
  "Heavy anti-armor vehicle": "خودروی سنگین ضدزره",
  "Fast raider": "مهاجم سریع",
  "Deployable tank": "تانک قابل استقرار",
  "Fast anti-armor vehicle": "خودروی سریع ضدزره",
  "Mobile ground / air defense": "دفاع متحرک زمینی / هوایی",
  "Heavy sonic vehicle": "خودروی سنگین صوتی",
  "Elite railgun vehicle": "خودروی نخبه با توپ ریلی",
  "Infantry transport": "نفربر پیاده‌نظام",
  "Infantry healer": "درمانگر پیاده‌نظام",
  "Captures neutral and enemy buildings": "تصرف ساختمان‌های بی‌طرف و دشمن",
  "Constructs and repairs buildings": "ساخت و تعمیر ساختمان‌ها",
  "Collects and delivers supplies": "جمع‌آوری و انتقال منابع",
  "Long-range artillery": "توپخانهٔ دوربرد",
  "Air superiority": "برتری هوایی",
  "Area-damage bomber": "بمب‌افکن با آسیب منطقه‌ای",
  "Fast airborne attacker": "مهاجم هوایی سریع",
  "Airborne scout": "شناسای هوایی",
  "Single-use ground strike": "حملهٔ زمینی یک‌بارمصرف",
  "Base command": "فرماندهی پایگاه",
  "Supplies base power": "تأمین برق پایگاه",
  "Receives supplies from trucks": "دریافت منابع از کامیون‌ها",
  "Infantry production": "تولید پیاده‌نظام",
  "Vehicle production": "تولید خودرو",
  "Unlocks advanced buildings": "بازکردن ساختمان‌های پیشرفته",
  "Unlocks advanced technology": "بازکردن فناوری پیشرفته",
  "Aircraft and drone production": "تولید هواگرد و پهپاد",
  "Passive income; 25% under low power": "درآمد دوره‌ای؛ ۲۵٪ با کمبود برق",
  "Engineer capture · Income after 10 seconds": "تصرف با مهندس · درآمد پس از 10 ثانیه",
  "Engineer capture · Free repair for one owned vehicle":
    "تصرف با مهندس · تعمیر رایگان یک خودروی خودی",
  "Engineer capture · Shared allied vision": "تصرف با مهندس · دید مشترک متحدان",
  "Ground pickup · 1000 Money": "برداشت زمینی · 1000 اعتبار",
  "Long-range missile support": "پشتیبانی موشکی دوربرد",
  "Long-range cruise missile support": "پشتیبانی موشک کروز دوربرد",
  "Anti-infantry defense": "دفاع ضدپیاده‌نظام",
  "Anti-armor defense": "دفاع ضدزره",
  "Infantry / vehicle defense": "دفاع در برابر پیاده‌نظام / خودرو",
  "Heavy anti-armor defense": "دفاع سنگین ضدزره",
  "Anti-air defense": "دفاع ضدهوایی",
  "Blocks ground movement": "مانع حرکت زمینی",
  "Ground hover vehicle with homing anti-air rockets. Cannot cross water.":
    "خودروی شناور زمینی با موشک‌های رهگیر ضدهوایی. از آب عبور نمی‌کند.",
  "Vehicles, buildings, and aircraft": "خودروها، ساختمان‌ها و هواگردها",
  "Heavy vehicle with a sonic weapon. Requires a Tech center.":
    "خودروی سنگین با سلاح صوتی. به مرکز فناوری نیاز دارد.",
  "Ground enemies": "دشمنان زمینی",
  "Massive rail-armed vehicle. Limited to one per owner, including queued units.":
    "خودروی عظیم با توپ ریلی. برای هر بازیکن، با احتساب صف تولید، فقط یکی مجاز است.",
  "Vehicles and buildings": "خودروها و ساختمان‌ها",
  "Groups of ground enemies": "گروه‌های دشمن زمینی",
  "Heavy-armored infantry with area plasma fire. Can be healed and transported. Limited to one per owner, including queued units.":
    "پیاده‌نظام زره‌سنگین با آتش پلاسمای منطقه‌ای. قابل درمان و حمل است. برای هر بازیکن، با احتساب صف تولید، فقط یکی مجاز است.",
  "Produces aircraft and drones. Requires radar and power.":
    "هواگرد و پهپاد تولید می‌کند. به رادار و برق نیاز دارد.",
  "Airborne fighter with homing rockets. Ignores terrain and walls.":
    "جنگنده با موشک‌های رهگیر. از موانع زمین و دیوار عبور می‌کند.",
  "Ground units, buildings and aircraft": "یگان‌های زمینی، ساختمان‌ها و هواگردها",
  "Airborne bomber that flies close to release area bombs.":
    "بمب‌افکن برای رهاکردن بمب‌های منطقه‌ای به هدف نزدیک می‌شود.",
  "Ground units and aircraft": "یگان‌های زمینی و هواگردها",
  "Fast airborne energy attacker.": "مهاجم هوایی سریع با سلاح انرژی.",
  "Ground units and buildings": "یگان‌های زمینی و ساختمان‌ها",
  "Powered anti-air defense. Cannot attack ground targets.":
    "دفاع ضدهوایی نیازمند برق. به اهداف زمینی حمله نمی‌کند.",
  "Aircraft and drones": "هواگردها و پهپادها",
  "Exclusive tower upgrade with anti-air missiles. Requires radar; cannot attack ground targets.":
    "ارتقای انحصاری برج با موشک ضدهوایی. به رادار نیاز دارد؛ به هدف زمینی حمله نمی‌کند.",
  "Unarmed airborne scout. Does not acquire targets automatically.":
    "شناسای هوایی بدون سلاح. به‌طور خودکار هدف نمی‌گیرد.",
  "Right-click a ground enemy to fly into it and detonate an explosive payload. Consumed on impact; shooting it down prevents detonation.":
    "روی دشمن زمینی راست‌کلیک کنید تا به آن برخورد و محمولهٔ انفجاری را منفجر کند. هنگام برخورد مصرف می‌شود؛ سرنگونی پیش از برخورد از انفجار جلوگیری می‌کند.",
  "Purchase one missile, prepare it, then launch when ready. Low power pauses preparation.":
    "یک موشک بخرید، آماده کنید و پس از آماده‌شدن پرتاب کنید. کمبود برق آماده‌سازی را متوقف می‌کند.",
  "Purchase one cruise missile, prepare it, then launch when ready. Low power pauses preparation.":
    "یک موشک کروز بخرید، آماده کنید و پس از آماده‌شدن پرتاب کنید. کمبود برق آماده‌سازی را متوقف می‌کند.",
  "Select any map position. All players receive a warning before the explosive strike. {0} or right-click cancels targeting.":
    "هر نقطه‌ای از نقشه را انتخاب کنید. پیش از انفجار به همه هشدار داده می‌شود. {0} یا راست‌کلیک هدف‌گیری را لغو می‌کند.",
  "Powerful energy base defense. Requires power.":
    "دفاع قدرتمند پایگاه با سلاح انرژی. به برق نیاز دارد.",
  "Exclusive tower upgrade with a heavier rapid-fire gun.":
    "ارتقای انحصاری برج با مسلسل سنگین‌تر و سریع‌تر.",
  Infantry: "پیاده‌نظام",
  "Exclusive tower upgrade with homing rockets. Requires radar.":
    "ارتقای انحصاری برج با موشک‌های رهگیر. به رادار نیاز دارد.",
  "Deploy to fire long-range area shells at visible targets. Cannot fire at close range.":
    "برای شلیک گلوله‌های دوربرد با آسیب منطقه‌ای مستقر شوید. در فاصلهٔ نزدیک شلیک نمی‌کند.",
  "Groups of enemies": "گروه‌های دشمن",
  "Right-click a neutral or enemy building and hold contact for 3 seconds to capture it, consuming the engineer. Headquarters and walls cannot be captured.":
    "با مهندس روی ساختمان بی‌طرف یا دشمن راست‌کلیک کنید و 3 ثانیه تماس را حفظ کنید. ساختمان تصرف و مهندس مصرف می‌شود. مقر فرماندهی و دیوار قابل تصرف نیستند.",
  "Toggle deployment. Units cannot move or fight during the transition. A movement order undeploys them first.":
    "حالت استقرار را تغییر دهید. هنگام تغییر حالت حرکت و حمله ممکن نیست. فرمان حرکت ابتدا یگان را از استقرار خارج می‌کند.",
  "Pays passive income when complete, at 25% under low power. Limited to three per owner.":
    "پس از تکمیل درآمد دوره‌ای می‌دهد؛ با کمبود برق ۲۵٪ است. هر بازیکن حداکثر سه عدد می‌سازد.",
  "Automatically heals one nearby damaged owned infantry at a time.":
    "هر بار یک پیاده‌نظام آسیب‌دیدهٔ خودی در نزدیکی را خودکار درمان می‌کند.",
  "Transports up to five infantry. Right-click with infantry to enter; Unload releases passengers.":
    "تا پنج پیاده‌نظام حمل می‌کند. با پیاده‌نظام روی آن راست‌کلیک کنید تا سوار شود؛ فرمان پیاده‌کردن مسافران را خارج می‌کند.",
  "Durable infantry armed with a chaingun.": "پیاده‌نظام مقاوم با مسلسل چرخان.",
  "Fast, lightly armored vehicle with homing rockets.": "خودروی سریع با زره سبک و موشک‌های رهگیر.",
  "Unlocks advanced buildings and turbine upgrades. Provides wide vision.":
    "ساختمان‌های پیشرفته و ارتقای توربین را باز می‌کند. دید وسیع فراهم می‌کند.",
  "Unlocks advanced technology.": "فناوری پیشرفته را باز می‌کند.",
  "Upgrades a Bastion generator's power output. The generator keeps working during installation.":
    "تولید برق نیروگاه باستین را ارتقا می‌دهد. نیروگاه هنگام نصب به کار خود ادامه می‌دهد.",
  "Produces builder vehicles that construct and repair buildings.":
    "خودروهای سازنده تولید می‌کند که ساختمان‌ها را می‌سازند و تعمیر می‌کنند.",
  "Supplies power to the base.": "برق پایگاه را تأمین می‌کند.",
  "Receives supplies. Includes one supply truck.":
    "منابع دریافت می‌کند. یک کامیون تدارکات همراه دارد.",
  "Trains the faction’s infantry roster.": "پیاده‌نظام جناح را تولید می‌کند.",
  "Produces the faction’s combat vehicles.": "خودروهای رزمی جناح را تولید می‌کند.",
  "Rapid-fire base defense. Requires power.": "دفاع سریع پایگاه. به برق نیاز دارد.",
  "Energy base defense. Requires power.": "دفاع انرژی پایگاه. به برق نیاز دارد.",
  "Anti-armor beam defense. Requires power.": "دفاع پرتوی ضدزره. به برق نیاز دارد.",
  "Infantry and vehicles": "پیاده‌نظام و خودروها",
  "Constructs and repairs buildings.": "ساختمان‌ها را می‌سازد و تعمیر می‌کند.",
  "Collects supplies and delivers them to a supply center.":
    "منابع را جمع می‌کند و به مرکز تدارکات می‌رساند.",
  "Low-cost infantry with a rifle.": "پیاده‌نظام ارزان با تفنگ.",
  "Infantry with an anti-armor rocket launcher.": "پیاده‌نظام با راکت‌انداز ضدزره.",
  "Infantry throwing explosive grenades that damage nearby targets.":
    "پیاده‌نظام نارنجک‌انداز با آسیب به اهداف نزدیک.",
  "Infantry and buildings": "پیاده‌نظام و ساختمان‌ها",
  "Fast vehicle armed with a rapid autocannon.": "خودروی سریع با توپ خودکار.",
  "Durable, slow vehicle carrying a heavy cannon.": "خودروی کند و مقاوم با توپ سنگین.",
  "Very fast raider armed with a machine gun.": "مهاجم بسیار سریع با مسلسل.",
  "Deploy for reduced incoming damage and increased cannon range.":
    "با استقرار، آسیب دریافتی کم و برد توپ بیشتر می‌شود.",
  "Select a world position. Units move and attack enemies along the route.":
    "یک نقطه از جهان را انتخاب کنید. یگان‌ها هنگام حرکت به دشمنان مسیر حمله می‌کنند.",
  "{0}: click to patrol from here to there. {1}+click adds up to eight points; a plain click finishes. Units fight and resume their patrol.":
    "{0}: برای گشت از اینجا تا مقصد کلیک کنید. {1}+کلیک تا هشت نقطه اضافه می‌کند؛ کلیک عادی مسیر را نهایی می‌کند. یگان‌ها پس از نبرد گشت را ادامه می‌دهند.",
  "Stops selected units at their current positions.":
    "یگان‌های انتخاب‌شده را در جای فعلی متوقف می‌کند.",
  "Returns part of the building cost. The production queue has no refund.":
    "بخشی از هزینهٔ ساختمان را بازمی‌گرداند. صف تولید بازپرداخت نمی‌شود.",
  "Cannot build here · Site blocked": "ساخت ممکن نیست · محل مسدود است",
  "Cannot build here · Outside the map": "ساخت ممکن نیست · بیرون نقشه",
  "Cannot build here · Invalid position": "ساخت ممکن نیست · موقعیت نامعتبر",
  "Cannot build · Unknown building": "ساخت ممکن نیست · ساختمان ناشناخته",
  "Cannot build · Missing prerequisite": "ساخت ممکن نیست · پیش‌نیاز ناقص",
  "Cannot build · Insufficient money": "ساخت ممکن نیست · اعتبار ناکافی",
  "Cannot build · Select a builder": "ساخت ممکن نیست · یک سازنده انتخاب کنید",
  "Outside builder area — move a builder closer": "بیرون محدودهٔ سازنده؛ سازنده را نزدیک‌تر کنید",
  "No builder available": "سازنده‌ای در دسترس نیست",
  "Cannot build · Building limit reached": "ساخت ممکن نیست · سقف ساختمان پر است",
  "Cannot build · Builder order queue full": "ساخت ممکن نیست · صف فرمان سازنده پر است",
  "Cannot build · Game over": "ساخت ممکن نیست · بازی تمام شده است",
  "Construction queued · Builder finishes current work first":
    "ساخت در صف قرار گرفت · سازنده ابتدا کار فعلی را تمام می‌کند",
  "Card details": "جزئیات کارت",
  "Hold {0} for armor, sight, speed and detailed capabilities":
    "برای جزئیات زره، دید، سرعت و توانایی‌ها {0} را نگه دارید",
  Objective: "هدف",
  "Destroy enemy ordinary buildings to win; objectives and walls do not prevent elimination":
    "برای پیروزی ساختمان‌های عادی دشمن را نابود کنید؛ اهداف نقشه و دیوارها مانع حذف بازیکن نمی‌شوند",
  Commands: "فرمان‌ها",
  "Select a unit or building first; the command grid follows the selection":
    "ابتدا یک یگان یا ساختمان انتخاب کنید؛ شبکهٔ فرمان با انتخاب شما تغییر می‌کند",
  "Select / add": "انتخاب / افزودن",
  "Left click or drag / {0}": "کلیک چپ یا کشیدن / {0}",
  "Move / attack / work": "حرکت / حمله / کار",
  "Right click on the world": "راست‌کلیک در جهان",
  Transport: "حمل‌ونقل",
  Turbine: "توربین",
  "Select a Bastion generator to buy its turbine upgrade after building a Radar station":
    "پس از ساخت ایستگاه رادار، نیروگاه باستین را انتخاب و ارتقای توربین را خریداری کنید",
  "Tower mounts": "سلاح‌های برج",
  "Select a Bastion tower to buy one exclusive gun, rocket, or SAM mount":
    "برج باستین را انتخاب و یکی از ارتقاهای انحصاری مسلسل، راکت یا موشک ضدهوایی را بخرید",
  Deploy: "استقرار",
  Capture: "تصرف",
  "Right-click neutral or enemy buildings with engineers; hold contact for 3 seconds; headquarters and walls are excluded":
    "با مهندس روی ساختمان بی‌طرف یا دشمن راست‌کلیک کنید؛ 3 ثانیه تماس لازم است؛ مقر فرماندهی و دیوار مستثنا هستند",
  "Trade posts pay passive income at 25% under low power; the money counter shows the rate":
    "پست‌های تجاری با کمبود برق ۲۵٪ درآمد دوره‌ای می‌دهند؛ نرخ در شمارندهٔ اعتبار نمایش داده می‌شود",
  Aircraft: "هواگردها",
  Drones: "پهپادها",
  "Strike drones require an explicit ground attack and are consumed on impact; impacts reveal the damage for five seconds":
    "پهپاد انتحاری به فرمان مستقیم حملهٔ زمینی نیاز دارد و هنگام برخورد مصرف می‌شود؛ آسیب برخورد را برای پنج ثانیه آشکار می‌کند",
  "Purchase a missile at a Strike center, wait for Ready, then Launch and click a target. Low power pauses preparation; Escape or right-click cancels targeting":
    "در مرکز موشکی یک موشک بخرید، تا آماده‌شدن صبر کنید، سپس پرتاب را انتخاب و روی هدف کلیک کنید. کمبود برق آماده‌سازی را متوقف می‌کند؛ Escape یا راست‌کلیک هدف‌گیری را لغو می‌کند",
  "Purchase a cruise missile at a Strike center, wait for Ready, then Launch and click a target. Low power pauses preparation; Escape or right-click cancels targeting":
    "در مرکز موشکی یک موشک کروز بخرید، تا آماده‌شدن صبر کنید، سپس پرتاب را انتخاب و روی هدف کلیک کنید. کمبود برق آماده‌سازی را متوقف می‌کند؛ Escape یا راست‌کلیک هدف‌گیری را لغو می‌کند",
  Stances: "حالت‌های رزمی",
  "Defend returns to its anchor; Aggressive pursues farther within a fixed boundary. Hold position fires in range without chasing. Stop preserves stance; Hold position now stops and adopts Hold.":
    "حالت دفاعی پس از تعقیب به نقطهٔ اولیه بازمی‌گردد؛ حالت تهاجمی در محدودهٔ مشخص بیشتر تعقیب می‌کند. حفظ موضع بدون تعقیب شلیک می‌کند. فرمان ایست حالت رزمی را حفظ می‌کند؛ حفظ موضع فوری، فرمان‌ها را متوقف و حالت حفظ موضع را فعال می‌کند.",
  "Hold fire": "عدم شلیک",
  "{0} selected": "{0} انتخاب‌شده",
  stats: "آمار",
  "Open Base": "باز کردن پایگاه",
  "Open Base ▸ {0}": "باز کردن پایگاه ▸ {0}",
  Formations: "آرایش‌ها",
  "Formation feedback": "بازخورد آرایش",
  "Previews and dashed endpoint ghosts are advisory. Applied, excluded, failed and adapted counts describe accepted placement. {0}, selection changes, pause or focus loss cancel placement.":
    "پیش‌نمایش و سایهٔ مقصد صرفاً راهنما هستند. تعداد اعمال‌شده، مستثنا، ناموفق و تطبیق‌یافته نتیجهٔ پذیرش موقعیت را نشان می‌دهد. {0}، تغییر انتخاب، توقف یا خروج تمرکز، جای‌گذاری را لغو می‌کند.",
  "Keep together": "حرکت هماهنگ",
  "Optional coordinated travel. Units fight before recovering their slots; late or blocked members Split and finish independently. Replacing orders detaches only selected members.":
    "حرکت هماهنگ اختیاری است. یگان‌ها پیش از بازگشت به جای خود می‌جنگند؛ اعضای دیررس یا مسدود جدا می‌شوند و مستقل ادامه می‌دهند. فرمان جایگزین فقط اعضای انتخاب‌شده را جدا می‌کند.",
  "Guard an area or owned building; Follow travels only; Escort protects around a moving owned target. These jobs block later queued orders until ended, replaced or stopped. Target loss never chooses a replacement.":
    "از منطقه یا ساختمان خودی نگهبانی کنید؛ دنبال‌کردن فقط حرکت می‌کند؛ اسکورت از اطراف هدف متحرک خودی دفاع می‌کند. تا پایان، توقف یا جایگزینی، این کارها فرمان‌های بعدی صف را نگه می‌دارند. با ازبین‌رفتن هدف، هدف جایگزین انتخاب نمی‌شود.",
  "Group lifetime": "ماندگاری گروه",
  "Groups and movement presets are local to this match; new matches, save/replay loading, page reload and full rejoin reset them. Transient reconnect retains surviving members.":
    "گروه‌ها و تنظیم‌های حرکت فقط برای همین نبرد هستند؛ بازی جدید، بارگیری ذخیره یا بازپخش، بازآوری و اتصال مجدد کامل آن‌ها را بازنشانی می‌کند. اتصال مجدد کوتاه، اعضای باقی‌مانده را حفظ می‌کند.",
  "Group chips": "دکمه‌های گروه",
  "Click a group to select it; double-click to center. Right-click to save selection, add units, rename or clear. Drag cards onto a group to add units. {0}-click a card to remove its type from selection, then save to update a group.":
    "برای انتخاب روی گروه کلیک کنید؛ برای مرکز کردن دوربین دوبار کلیک کنید. با راست‌کلیک انتخاب را ذخیره کنید، یگان اضافه کنید، نام را تغییر دهید یا گروه را پاک کنید. برای افزودن یگان، کارت را روی گروه بکشید. برای حذف یک نوع از انتخاب، با {0} روی کارت کلیک کنید؛ سپس انتخاب را در گروه ذخیره کنید.",
  "Queue orders": "صف فرمان‌ها",
  "Hold {0} and right click to queue moves, attack-moves, and attacks":
    "برای صف‌کردن حرکت، حرکت تهاجمی و حمله، {0} را نگه دارید و راست‌کلیک کنید",
  "{0}, then click for a loop from here; {1}+click adds points, plain click finishes (eight maximum)":
    "{0}، سپس کلیک برای حلقهٔ گشت از اینجا؛ {1}+کلیک نقطه اضافه می‌کند و کلیک عادی مسیر را تمام می‌کند (حداکثر هشت نقطه)",
  "Queue construction": "صف ساخت",
  "New buildings queue behind active work; {0} keeps placement":
    "ساختمان جدید پشت کار فعال در صف قرار می‌گیرد؛ {0} حالت جای‌گذاری را نگه می‌دارد",
  "Build / train": "ساخت / تولید",
  "Open a category, then use {0}; {1} queues five units":
    "یک دسته را باز کنید و از {0} استفاده کنید؛ {1} پنج یگان را در صف قرار می‌دهد",
  "Attack-move / stop": "حرکت تهاجمی / ایست",
  "Production categories": "دسته‌های تولید",
  "Open any category; training uses a compatible selected building or another owned producer":
    "هر دسته را باز کنید؛ تولید از ساختمان سازگار انتخاب‌شده یا تولیدکنندهٔ خودی دیگری انجام می‌شود",
  "Worker areas": "محدودهٔ کارگران",
  "Builders and supply trucks work locally; move them to establish a new area or order a specific supply route":
    "سازنده و کامیون تدارکات محلی کار می‌کنند؛ برای تعیین محدودهٔ جدید آن‌ها را جابه‌جا کنید یا مسیر منابع مشخص بدهید",
  Walls: "دیوارها",
  "Click a start, preview the line, then click the endpoint to queue the whole chain":
    "نقطهٔ شروع را انتخاب کنید، خط را ببینید و سپس نقطهٔ پایان را برای صف‌کردن کل زنجیره انتخاب کنید",
  "Cycle idle builders": "انتخاب سازندگان بیکار",
  "Low power slows production to 25%": "کمبود برق سرعت تولید را به 25% می‌رساند",
  "Store / select group": "ذخیره / انتخاب گروه",
  "{0} + {1} / {1}": "{0} + {1} / {1}",
  "Center on group": "تمرکز دوربین روی گروه",
  "Press the group number twice": "عدد گروه را دوبار فشار دهید",
  "Camera / zoom": "دوربین / بزرگ‌نمایی",
  "{0}, arrow keys, or screen edges / mouse wheel": "{0}، کلیدهای جهت یا لبه‌های صفحه / چرخ ماوس",
  Minimap: "نقشهٔ کوچک",
  "Left click or drag to view; right click to move; {0} queues":
    "کلیک چپ یا کشیدن برای مشاهده؛ راست‌کلیک برای حرکت؛ {0} برای صف",
  "Select a producer, then right click on the world":
    "تولیدکننده را انتخاب و سپس در جهان راست‌کلیک کنید",
  "Cancel / pause": "لغو / توقف",
  "{0} closes the build flyout; otherwise opens the menu":
    "{0} فهرست ساخت را می‌بندد؛ در غیر این صورت منو را باز می‌کند",
  "{0} or {1}": "{0} یا {1}",
  "Highest {0} wins when time expires. Ties are draws.":
    "با پایان زمان، بیشترین {0} برنده است. امتیاز برابر یعنی مساوی.",
  "Room options": "تنظیمات اتاق",
  "Units ": "یگان‌ها ",
  Unlimited: "نامحدود",
  MAP: "نقشه",
  Map: "نقشه",
  PLAYERS: "بازیکنان",
  TEAMS: "تیم‌ها",
  "Team mode": "حالت تیمی",
  "Free-for-all": "همه علیه همه",
  Teams: "تیم‌ها",
  "Players may pick their team": "بازیکنان می‌توانند تیم خود را انتخاب کنند",
  "Population cap": "سقف جمعیت",
  "TIME LIMIT": "محدودیت زمان",
  Speed: "سرعت",
  "START MONEY": "پول اولیه",
  "Starting money": "پول اولیه",
  "Time limit": "محدودیت زمان",
  "At the time limit, the highest combined score of surviving team members wins. Ties are draws.":
    "در پایان زمان، تیمی که مجموع امتیاز اعضای باقی‌مانده‌اش بیشتر باشد برنده است. امتیاز برابر به مساوی می‌انجامد.",
  "At the time limit, the surviving player with the highest score wins. Ties are draws.":
    "در پایان زمان، بازیکن باقی‌مانده با بیشترین امتیاز برنده است. امتیاز برابر به مساوی می‌انجامد.",
  "Score includes banked money, surviving units and buildings, and enemy assets destroyed.":
    "امتیاز شامل پول ذخیره‌شده، نیروها و ساختمان‌های باقی‌مانده و دارایی‌های نابودشدهٔ دشمن است.",
  "Peace comes before the combat time limit.": "دورهٔ صلح پیش از شروع محدودیت زمان نبرد است.",
  "Input delay": "تأخیر ورودی",
  Auto: "خودکار",
  "Fill empty seats with AI": "پرکردن جایگاه‌های خالی با هوش مصنوعی",
  "Auto balance": "توازن خودکار",
  "Resume in 3…": "ادامهٔ بازی 3 ثانیهٔ دیگر…",
  "Resuming in {0}…": "ادامهٔ بازی {0} ثانیهٔ دیگر…",
  "Abandon your side?": "جناح خود را ترک می‌کنید؟",
  "This eliminates your side. Click again to confirm.":
    "این کار جناح شما را حذف می‌کند. برای تأیید دوباره کلیک کنید.",
  Resign: "تسلیم",
  "Resigned. Your side is eliminated.": "تسلیم شدید. جناح شما حذف شد.",
  "Leave for good?": "خروج دائمی؟",
  "This abandons the match. Click again to confirm.":
    "این کار نبرد را ترک می‌کند. برای تأیید دوباره کلیک کنید.",
  "Leave match": "ترک نبرد",
  "Leave and find a match": "ترک نبرد و یافتن نبرد جدید",
  "You are eliminated. Your team result still counts if you leave.":
    "شما حذف شده‌اید. اگر خارج شوید، نتیجهٔ تیم همچنان برای شما ثبت می‌شود.",
  "No replay available for this match.": "برای این نبرد بازپخشی موجود نیست.",
  "Replay downloaded. The viewer plays it from the menu.":
    "بازپخش دریافت شد. می‌توانید آن را از منو تماشا کنید.",
  "Room closed or expired.": "اتاق بسته یا منقضی شد.",
  "Server busy. Retrying…": "سرور مشغول است. تلاش مجدد…",
  "Match already ended.": "نبرد قبلاً تمام شده است.",
  "Lost the server. Retrying…": "ارتباط با سرور قطع شد. تلاش مجدد…",
  "Copy unavailable — select the code by hand.": "کپی ممکن نیست؛ کد را دستی انتخاب کنید.",
  "Copy failed — select the code by hand.": "کپی ناموفق بود؛ کد را دستی انتخاب کنید.",
  "Joining as {0}…": "در حال پیوستن به‌عنوان {0}…",
  "Joined as {0}. Press Ready when set.": "به‌عنوان {0} پیوستید. پس از آمادگی دکمهٔ آماده را بزنید.",
  "Could not join that side. It may be taken.":
    "پیوستن به این جناح ممکن نشد. شاید قبلاً گرفته شده باشد.",
  "Waiting for every side to be ready…": "در انتظار آمادگی همهٔ جناح‌ها…",
  "Link copied — share it to invite.": "پیوند کپی شد؛ برای دعوت آن را بفرستید.",
  "Code copied.": "کد کپی شد.",
  "Choose an available map.": "یک نقشهٔ موجود انتخاب کنید.",
  "That map or human limit cannot support this player count.":
    "این نقشه یا سقف بازیکن انسانی از این تعداد پشتیبانی نمی‌کند.",
  "Choose valid AI seats.": "جایگاه‌های معتبر برای هوش مصنوعی انتخاب کنید.",
  "Choose Easy, Normal, or Hard difficulty.": "دشواری آسان، عادی یا سخت را انتخاب کنید.",
  "Choose a valid faction.": "یک جناح معتبر انتخاب کنید.",
  "Choose Auto, 3, 5, or 8 turns.": "خودکار یا 3، 5 یا 8 نوبت را انتخاب کنید.",
  "Choose a population cap of 60, 100, or 150.": "سقف جمعیت 60، 100 یا 150 را انتخاب کنید.",
  "Choose Quick, Standard, or Long.": "سریع، استاندارد یا طولانی را انتخاب کنید.",
  "Choose a starting money amount from the list.": "یکی از مقدارهای پول اولیه را انتخاب کنید.",
  "Choose Slow, Normal, or Fast.": "آهسته، عادی یا سریع را انتخاب کنید.",
  "Choose Teams to assign teams.": "برای تعیین تیم‌ها حالت تیمی را انتخاب کنید.",
  "Choose whether players may pick their team.":
    "مشخص کنید آیا بازیکنان می‌توانند تیم خود را انتخاب کنند.",
  "Choose valid teams for every seat.": "برای همهٔ جایگاه‌ها تیم معتبر تعیین کنید.",
  "Choose an available team.": "یک تیم موجود انتخاب کنید.",
  "Choose an available seat.": "یک جایگاه موجود انتخاب کنید.",
  "These room options are invalid.": "تنظیمات اتاق نامعتبر است.",
  "This room action is unavailable.": "این عملیات اتاق در دسترس نیست.",
  "These options cannot form a match.": "این تنظیمات نمی‌توانند نبردی تشکیل دهند.",
  "Unready all players before changing room options.":
    "پیش از تغییر تنظیمات، آمادگی همهٔ بازیکنان را لغو کنید.",
  "Leave occupied seats open to their players.":
    "جایگاه‌های اشغال‌شده را برای بازیکنانشان نگه دارید.",
  "Keep at least one human seat.": "حداقل یک جایگاه انسانی نگه دارید.",
  "Only the host can change this option.": "فقط میزبان می‌تواند این گزینه را تغییر دهد.",
  "You can change your own faction or an allowed team; the host can change AI factions.":
    "می‌توانید جناح خود یا تیم مجاز را تغییر دهید؛ میزبان می‌تواند جناح هوش مصنوعی را تغییر دهد.",
  "Take a seat first.": "ابتدا یک جایگاه بگیرید.",
  "That seat is empty.": "آن جایگاه خالی است.",
  "The host cannot be kicked.": "میزبان را نمی‌توان اخراج کرد.",
  "The match has already started.": "نبرد قبلاً شروع شده است.",
  "You were kicked from this seat.": "از این جایگاه اخراج شدید.",
  "Could not change the room. Try again.": "تغییر اتاق ممکن نشد. دوباره تلاش کنید.",
  "Lost the server. Try again.": "ارتباط با سرور قطع شد. دوباره تلاش کنید.",
  "A new version is live. Reload the page.": "نسخهٔ جدید منتشر شده است. صفحه را بازآوری کنید.",
  "You were kicked from the room.": "از اتاق اخراج شدید.",
  " · PAUSED": " · متوقف",
  "{0} · Frozen: {1}": "{0} · متوقف‌شده: {1}",
  " · Disconnected": " · قطع اتصال",
  "Maintenance: server stops in {0} s": "تعمیرات: سرور تا {0} ثانیه دیگر متوقف می‌شود",
  " · {0} s remaining": " · {0} ثانیه باقی‌مانده",
  " · Reconnecting": " · اتصال مجدد",
  " · Paused by {0}": " · متوقف‌شده توسط {0}",
  "{0} · Starved — no server update ({1}s)": "{0} · انتظار؛ به‌روزرسانی سرور نرسیده است ({1} ثانیه)",
  "Paused by agreement. Pauses used {0}/{1}.": "نبرد با توافق متوقف است. توقف‌های مصرف‌شده {0}/{1}.",
  "The battle keeps running while this menu is open. Pauses used {0}/{1}.":
    "نبرد هنگام بازبودن این منو ادامه دارد. توقف‌های مصرف‌شده {0}/{1}.",
  "Exit to menu": "بازگشت به منو",
  Rematch: "بازی دوباره",
  "Waiting for {0} players": "در انتظار {0} بازیکن",
  "Invited by {0}": "دعوت از طرف {0}",
  Accept: "پذیرفتن",
  Decline: "رد کردن",
  "Join rematch lobby": "ورود به اتاق بازی دوباره",
  "Rematch invite expired.": "مهلت دعوت بازی دوباره تمام شد.",
  "Rematch invite declined.": "دعوت بازی دوباره رد شد.",
  "Rematch request failed.": "درخواست بازی دوباره انجام نشد.",
  "Return to menu": "بازگشت به منو",
  "Back to home": "بازگشت به خانه",
  "◂ Back": "بازگشت ◂",
  "Host a room": "ساخت اتاق",
  "Optional — leave blank for a guest name": "اختیاری؛ برای نام مهمان خالی بگذارید",
  "Your display name": "نام نمایشی شما",
  "Edit name": "تغییر نام",
  "A name needs 2–16 characters.": "نام باید ۲ تا ۱۶ نویسه داشته باشد.",
  BATTLEFIELD: "میدان نبرد",
  Battlefield: "میدان نبرد",
  "Creating…": "در حال ساخت…",
  "Create room": "ساخت اتاق",
  "Server busy. All match slots are in use. Try again after a match ends.":
    "سرور مشغول است. همهٔ جایگاه‌های نبرد پر هستند. پس از پایان یک نبرد دوباره تلاش کنید.",
  "Pick an open side to join.": "یک جناح خالی برای پیوستن انتخاب کنید.",
  "Ready — waiting for the other side…": "آماده؛ در انتظار جناح دیگر…",
  "Sides set. Press Ready when set.": "جناح‌ها مشخص‌اند. پس از آمادگی دکمهٔ آماده را بزنید.",
  "Loading the room…": "در حال بارگیری اتاق…",
  "The match has started.": "نبرد شروع شده است.",
  "Unready all players to change options.": "برای تغییر گزینه‌ها آمادگی همه را لغو کنید.",
  "The match": "نبرد",
  "Ready — waiting for every player.": "آماده؛ در انتظار همهٔ بازیکنان.",
  "The match could not start. Try again.": "نبرد شروع نشد. دوباره تلاش کنید.",
  "Assign at least two opposing teams.": "حداقل دو تیم رقیب تعیین کنید.",
  "Take every open seat or fill it with AI.": "همهٔ جایگاه‌ها را بگیرید یا با هوش مصنوعی پر کنید.",
  "Wait for every seated player to reconnect.": "منتظر اتصال دوبارهٔ همهٔ بازیکنان جایگاه‌دار بمانید.",
  "Waiting for the room.": "در انتظار اتاق.",
  "Playing as ": "بازی به‌عنوان ",
  Edit: "ویرایش",
  Done: "تأیید",
  "QUICK JOIN": "پیوستن سریع",
  "Room code to join": "کد اتاق برای پیوستن",
  "Room code character {0}": "نویسهٔ {0} کد اتاق",
  "Join room": "پیوستن به اتاق",
  or: "یا",
  "Take seat {0} ({1})": "گرفتن جایگاه {0} ({1})",
  "Seat {0} ({1})": "جایگاه {0} ({1})",
  YOU: "شما",
  " · YOU": " · شما",
  Host: "میزبان",
  "Latency unknown": "تأخیر نامشخص است",
  "Latency {0} ms": "تأخیر {0} میلی‌ثانیه",
  Faction: "جناح",
  "Faction for seat {0}": "جناح جایگاه {0}",
  "Team ": "تیم ",
  "Team for seat {0}": "تیم جایگاه {0}",
  Seat: "جایگاه",
  "Type for seat {0}": "نوع جایگاه {0}",
  Easy: "آسان",
  Hard: "سخت",
  Kick: "اخراج",
  "Clear kick": "لغو اخراج",
  "Leave seat": "ترک جایگاه",
  Take: "گرفتن",
  "Friend room lobby": "اتاق بازی دوستانه",
  "Room code": "کد اتاق",
  "Copy link": "کپی پیوند",
  "Copy code": "کپی کد",
  "A slow connection slows the whole match for everyone.": "اتصال کند، نبرد را برای همه کند می‌کند.",
  "Game starts in {0}…": "بازی {0} ثانیهٔ دیگر شروع می‌شود…",
  "Preparing battlefield…": "در حال آماده‌سازی میدان نبرد…",
  "Starting game…": "در حال شروع بازی…",
  "You can still unready.": "هنوز می‌توانید آمادگی را لغو کنید.",
  Leave: "ترک اتاق",
  "Retry start": "تلاش مجدد برای شروع",
  Unready: "لغو آمادگی",
  "NETWORK MATCH": "نبرد شبکه‌ای",
  "{0} never pauses the shared battle. Use the protocol pause so every side agrees.":
    "{0} نبرد مشترک را متوقف نمی‌کند. از درخواست توقف استفاده کنید تا همه موافق باشند.",
  "Request pause": "درخواست توقف",
  "Could not start a guest session. Try again.": "ساخت نشست مهمان ممکن نشد. دوباره تلاش کنید.",
  "Server unreachable. Start it with `bun run dev`.":
    "سرور در دسترس نیست. آن را با `bun run dev` اجرا کنید.",
  "That map holds fewer owners. Pick fewer owners or another map.":
    "این نقشه جایگاه کمتری دارد. تعداد بازیکنان را کم یا نقشه را عوض کنید.",
  "Could not create the room ({0}).": "ساخت اتاق ممکن نشد ({0}).",
  "No open room has that code.": "هیچ اتاق بازی با این کد موجود نیست.",
  "Download replay": "دریافت بازپخش",
  "Decided in battle.": "نتیجه در میدان نبرد تعیین شد.",
  "Time limit — {0} holds the highest score.": "محدودیت زمان؛ {0} بیشترین امتیاز را دارد.",
  "Time limit.": "محدودیت زمان.",
  "Draw — no side prevails.": "مساوی؛ هیچ جناحی پیروز نشد.",
  "Conflicting reports — no winner is named.": "گزارش‌های ناسازگار؛ برنده‌ای اعلام نمی‌شود.",
  "Desync at tick {0} — the battles diverged, play is frozen, no winner. Save the diagnostic replay.":
    "ناهماهنگی در تیک {0}؛ نبردها متفاوت شدند، بازی متوقف است و برنده‌ای ندارد. بازپخش عیب‌یابی را ذخیره کنید.",
  "The match stalled — no winner is named.": "نبرد متوقف ماند؛ برنده‌ای اعلام نمی‌شود.",
  "The server aborted the match — no winner is named.":
    "سرور نبرد را لغو کرد؛ برنده‌ای اعلام نمی‌شود.",
  "Build mismatch — every side must run the same version.":
    "نسخه‌ها متفاوت‌اند؛ همه باید یک نسخه را اجرا کنند.",
  "Match ended ({0}).": "نبرد پایان یافت ({0}).",
  "Save diagnostic replay": "ذخیرهٔ بازپخش عیب‌یابی",
  "Frozen: {0}. Save the diagnostic replay.": "متوقف‌شده: {0}. بازپخش عیب‌یابی را ذخیره کنید.",
  "A new game version is available.": "نسخهٔ جدید بازی موجود است.",
  "Press {0} to view": "برای مشاهده {0} را فشار دهید",
  Space: "Space",
  Cancel: "لغو",
  "Supply dock": "انبار منابع",
  "Shrink tactical map": "کوچک‌کردن نقشهٔ تاکتیکی",
  "Expand tactical map": "بزرگ‌کردن نقشهٔ تاکتیکی",
  "Tactical map. Armed strike, guard, follow or escort uses left click to target. Right click cancels targeting. Otherwise left click views, right click moves. {0} queues.":
    "نقشهٔ تاکتیکی. در حالت حمله، نگهبانی، دنبال‌کردن یا اسکورت، کلیک چپ هدف می‌گیرد و راست‌کلیک هدف‌گیری را لغو می‌کند. در غیر این صورت کلیک چپ مشاهده و راست‌کلیک حرکت است. {0} فرمان را در صف می‌گذارد.",
  "VIEW / LEFT · MOVE / RIGHT · QUEUE / {0}": "مشاهده / چپ · حرکت / راست · صف / {0}",
  PAUSED: "متوقف",
  Menu: "منو",
  Continue: "ادامه",
  "MATCH FILES": "فایل‌های نبرد",
  SOUND: "صدا",
  DISPLAY: "نمایش",
  CONTROLS: "کنترل‌ها",
  Music: "موسیقی",
  Effects: "جلوه‌های صوتی",
  Voice: "گفتار",
  Graphics: "گرافیک",
  "Frame rate": "نرخ فریم",
  "Game speed": "سرعت بازی",
  Score: "امتیاز",
  "Units built": "یگان‌های تولیدشده",
  "Units lost": "یگان‌های ازدست‌رفته",
  "Enemy units destroyed": "یگان‌های دشمن نابودشده",
  "Buildings built": "ساختمان‌های ساخته‌شده",
  "Buildings lost": "ساختمان‌های ازدست‌رفته",
  "Resources collected": "منابع جمع‌آوری‌شده",
  "Resources spent": "منابع مصرف‌شده",
  "War loot": "غنیمت جنگی",
  "Lost to upkeep": "ازدست‌رفته به هزینهٔ نگهداری",
  "No upkeep": "بدون هزینهٔ نگهداری",
  "Low upkeep −{0}%": "نگهداری کم −{0}٪",
  "High upkeep −{0}%": "نگهداری زیاد −{0}٪",
  "Raises upkeep to −{0}%": "هزینهٔ نگهداری را به −{0}٪ می‌رساند",
  "Army upkeep. Builders and haulers do not count.":
    "هزینهٔ نگهداری ارتش. سازنده‌ها و باربرها حساب نمی‌شوند.",
  "0–{0} army pop: 100% income": "جمعیت ارتش ۰ تا {0}: ۱۰۰٪ درآمد",
  "{0}–{1} army pop: {2}% income": "جمعیت ارتش {0} تا {1}: {2}٪ درآمد",
  "{0}+ army pop: {1}% income": "جمعیت ارتش {0} و بیشتر: {1}٪ درآمد",
  "Army pop: {0}": "جمعیت ارتش: {0}",
  "{0} army pop left before the next tier": "{0} جمعیت ارتش تا ردهٔ بعدی",
  "Credits lost to upkeep: {0}": "اعتبار ازدست‌رفته به نگهداری: {0}",
  Left: "خارج‌شده",
  "Win{0}": "برد{0}",
  "Draw{0}": "مساوی{0}",
  "Lose{0}": "باخت{0}",
  Lose: "باخت",
  Winners: "برندگان",
  Draw: "مساوی",
  Defeated: "شکست‌خورده",
  "No result": "بدون نتیجه",
  "Play online": "بازی آنلاین",
  Skirmish: "نبرد تک‌نفره",
  Archive: "بایگانی",
  "Field guide": "راهنمای میدانی",
  Settings: "تنظیمات",
  "The match froze{0} before a result — no winner is named.":
    "نبرد پیش از نتیجه متوقف شد{0}؛ برنده‌ای اعلام نمی‌شود.",
  "Your team": "تیم شما",
  You: "شما",
  "The team of {0}": "تیم {0}",
  "Score deadline reached — you hold the highest score.":
    "زمان بازی تمام شد؛ شما بیشترین امتیاز را دارید.",
  "Score deadline reached — {0} holds the highest score.":
    "زمان بازی تمام شد؛ {0} بیشترین امتیاز را دارد.",
  "Draw — the scores tie at the time limit.": "مساوی؛ امتیازها در پایان زمان برابرند.",
  "Draw — the last owners were eliminated in the same moment.":
    "مساوی؛ آخرین بازیکنان هم‌زمان حذف شدند.",
  "No winner — the final state reports disagreed.": "بدون برنده؛ گزارش وضعیت نهایی یکسان نبود.",
  "You resigned": "تسلیم شدید",
  "Desync at turn {0} — the simulations disagreed, so the match ends without a winner.":
    "ناهماهنگی در نوبت {0}؛ شبیه‌سازی‌ها یکسان نبودند و نبرد بدون برنده تمام می‌شود.",
  "Connection stalled — the match timed out without a winner.":
    "اتصال متوقف ماند؛ مهلت نبرد بدون برنده تمام شد.",
  "Build mismatch — every player must run the same game version.":
    "نسخه‌ها متفاوت‌اند؛ همه باید یک نسخهٔ بازی داشته باشند.",
  "You · {0}": "شما · {0}",
  "Players of the finished match": "بازیکنان نبرد تمام‌شده",
  Player: "بازیکن",
  Outcome: "نتیجه",
  "Play again": "بازی دوباره",
  "Smaller forces · slower reactions": "نیروهای کوچک‌تر · واکنش کندتر",
  "Balanced forces · normal reactions": "نیروهای متعادل · واکنش معمولی",
  "Larger forces · faster reactions": "نیروهای بزرگ‌تر · واکنش سریع‌تر",
  Borderlands: "سرزمین مرزی",
  "Load match…": "بارگیری بازی…",
  "Watch record…": "تماشای بازپخش…",
  "Load saved match…": "بارگیری بازی ذخیره‌شده…",
  "Watch battle record…": "تماشای بازپخش نبرد…",
  "Skip to end": "رفتن به پایان",
  "Battle archive": "بایگانی نبرد",
  "Quit ends the battle with no result. Click again to confirm.":
    "خروج، نبرد را بدون نتیجه تمام می‌کند. برای تأیید دوباره کلیک کنید.",
  "Resign counts as a defeat and shows the result. Click again to confirm.":
    "تسلیم به‌عنوان شکست ثبت می‌شود و نتیجه را نشان می‌دهد. برای تأیید دوباره کلیک کنید.",
  Paused: "متوقف",
  "End battle and load?": "پایان نبرد و بارگیری؟",
  "End battle and watch?": "پایان نبرد و تماشا؟",
  "This ends the current battle. Click again to confirm.":
    "این کار نبرد فعلی را تمام می‌کند. برای تأیید دوباره کلیک کنید.",
  "Saved match downloaded. Load it later to keep playing from this moment.":
    "فایل ذخیره دریافت شد. بعداً از همین لحظه ادامه دهید.",
  "Battle record downloaded. It replays exactly what happened.":
    "بازپخش دریافت شد و همان رویدادهای نبرد را نمایش می‌دهد.",
  "Saved match loaded — keep playing from this moment.":
    "بازی ذخیره‌شده بارگیری شد؛ از همین لحظه ادامه دهید.",
  "That saved-match file is too large to open. The current battle is untouched.":
    "حجم فایل ذخیره برای بازکردن بیش از حد است. نبرد فعلی تغییر نکرده است.",
  "That battle-record file is too large to open. The current battle is untouched.":
    "حجم فایل بازپخش برای بازکردن بیش از حد است. نبرد فعلی تغییر نکرده است.",
  "That file was set aside — a newer battle started. Pick the file again to replace it.":
    "فایل کنار گذاشته شد؛ نبرد جدیدتری شروع شده است. برای جایگزینی دوباره فایل را انتخاب کنید.",
  "Could not read that file. The current battle is untouched.":
    "فایل خوانده نشد. نبرد فعلی تغییر نکرده است.",
  "Skipping…": "در حال رفتن به پایان…",
  "You are eliminated — you hold no buildings. Keep watching or leave the match.":
    "حذف شدید؛ ساختمانی ندارید. تماشا را ادامه دهید یا نبرد را ترک کنید.",
  "The {0} file picker is not mounted.": "انتخابگر فایل {0} آماده نیست.",
  "FIELD MANUAL": "راهنمای میدانی",
  "Secure supplies, grow your base, and destroy every enemy building.":
    "منابع را امن کنید، پایگاه را گسترش دهید و ساختمان‌های دشمن را نابود کنید.",
  DIFFICULTY: "دشواری",
  "Play as {0}": "بازی با {0}",
  OPPONENTS: "حریفان",
  Battlefields: "میدان‌های نبرد",
  BATTLEFIELDS: "میدان‌های نبرد",
  FACTION: "جناح",
  "Your faction": "جناح شما",
  "Highest score wins when time expires. Ties are draws.":
    "با پایان زمان، بیشترین امتیاز برنده است. امتیاز برابر یعنی مساوی.",
  "UNIT LIMIT PER PLAYER": "سقف یگان هر بازیکن",
  "Unit limit per player": "سقف یگان هر بازیکن",
  "Start battle": "شروع نبرد",
  "Match frozen": "نبرد متوقف مانده است",
  "Match ended": "نبرد تمام شده است",
  "Teams {0}": "تیم‌ها {0}",
  "Units {0}": "یگان‌ها {0}",
  "Confirm quit": "تأیید خروج",
  "Quit to menu": "خروج به منو",
  "Confirm resign": "تأیید تسلیم",
  "The download link is not mounted.": "پیوند دریافت فایل آماده نیست.",
  "REAL-TIME STRATEGY": "استراتژی هم‌زمان",
  RAZMAK: "رزمک",
  "Small war. Fast hands.": "جنگ کوچک، تصمیم‌های بزرگ",
  "Main menu": "منوی اصلی",
  "Quick join": "پیوستن سریع",
  "Exit record": "خروج از بازپخش",
  "Keep watching": "ادامهٔ تماشا",
  "Ready to claim": "آمادهٔ دریافت",
  "Match over": "نبرد تمام شده است",
  "No owner": "بدون بازیکن",
  Eliminated: "حذف‌شده",
  "Already claimed this match": "در این نبرد قبلاً دریافت شده است",
  "Needs a living building": "به یک ساختمان سالم نیاز دارد",
  "Income already running": "درآمد از قبل برقرار است",
  "You can afford a restart": "بودجهٔ شروع دوباره را دارید",
  "Economic recovery in progress": "بازیابی اقتصادی در جریان است",
  "Recovery not ready": "بازیابی آماده نیست",
  "Not enough population": "ظرفیت جمعیت کافی نیست",
  "No free spawn point": "نقطهٔ ظهور خالی موجود نیست",
  "No supply center": "مرکز تدارکات موجود نیست",
  "No supply truck": "کامیون تدارکات موجود نیست",
  "No economic restart available": "شروع دوبارهٔ اقتصاد ممکن نیست",
  "Cannot afford construction": "هزینهٔ ساخت را ندارید",
  "Cannot afford a supply truck": "هزینهٔ کامیون تدارکات را ندارید",
  "Recovery available in {0}s": "بازیابی تا {0} ثانیهٔ دیگر ممکن است",
  "Supply center: {0}": "مرکز تدارکات: {0}",
  "Supply truck: {0}": "کامیون تدارکات: {0}",
  "Income: running": "درآمد: برقرار",
  "Economic build: in progress": "ساخت اقتصادی: در جریان",
  "Restart cost: unavailable": "هزینهٔ شروع دوباره: نامشخص",
  "Funds: {0} of {1}": "اعتبار: {0} از {1}",
  "Wait: {0}s": "انتظار: {0} ثانیه",
  "Spawn: blocked": "محل ظهور: مسدود",
  "Available in {0}s": "تا {0} ثانیهٔ دیگر موجود است",
  Claimed: "دریافت‌شده",
  "Income active": "درآمد فعال",
  "Emergency recovery · +{0} · builder + hauler": "بازیابی اضطراری · +{0} · سازنده + کامیون",
  "Recovery refused · {0}": "بازیابی پذیرفته نشد · {0}",
  "Production queue": "صف تولید",
  Build: "ساخت",
  QUEUE: "صف",
  "Cancel {0}": "لغو {0}",
  "Holds {0} players": "ظرفیت {0} بازیکن",
  "Hold ": "نگه‌داشتن ",
  Alt: "Alt",
  " for details": " برای جزئیات",
  Production: "تولید",
  Prod: "تولید",
  Def: "دفاع",
  Inf: "پیاده",
  Veh: "خودرو",
  " · Low power {0}% speed": " · کمبود برق؛ سرعت {0}%",
  SELECT: "انتخاب",
  "Idle builder": "سازندهٔ بیکار",
  "Purchase missile": "خرید موشک",
  "Purchase cruise missile": "خرید موشک کروز",
  "Cancel missile preparation": "لغو آماده‌سازی موشک",
  "Cancel cruise missile preparation": "لغو آماده‌سازی موشک کروز",
  COMMANDS: "فرمان‌ها",
  "MISSILE STRIKE · SELECT EXPLORED POSITION · ESC TO CANCEL":
    "حملهٔ موشکی · محل کشف‌شده را انتخاب کنید · Esc برای لغو",
  "CRUISE MISSILE · SELECT EXPLORED POSITION · {0} TO CANCEL":
    "حملهٔ موشک کروز · محل کشف‌شده را انتخاب کنید · {0} برای لغو",
  "PLACE {0} · {1} TO CANCEL": "جای‌گذاری {0} · {1} برای لغو",
  "PATROL · {0}+CLICK ADDS POINTS · CLICK FINISHES":
    "گشت · {0}+کلیک برای افزودن نقطه · کلیک برای پایان",
  "ATTACK-MOVE · SELECT A POSITION": "حرکت تهاجمی · یک موقعیت انتخاب کنید",
  "RALLY · SELECT A POSITION · {0} TO CANCEL": "تجمع · یک موقعیت انتخاب کنید · {0} برای لغو",
  Undeploy: "جمع‌کردن تجهیزات",
  "No passengers": "بدون مسافر",
  "Deployment in progress": "استقرار در جریان است",
  "{0} limit reached · Includes queued units": "سقف {0} پر است · با احتساب یگان‌های در صف",
  "Building limit reached": "سقف ساختمان پر است",
  "Population cap reached": "سقف جمعیت پر است",
  "Building already upgraded": "ساختمان قبلاً ارتقا یافته است",
  "Upgrade in progress": "ارتقا در جریان است",
  "Building under construction": "ساختمان در حال ساخت است",
  "Faction access required": "دسترسی جناح لازم است",
  "Airfield parking capacity reached": "ظرفیت توقفگاه هوایی پر است",
  "Drone pad capacity reached": "ظرفیت سکوهای پهپاد پر است",
  "Production queue full": "صف تولید پر است",
  Unavailable: "در دسترس نیست",
  "Bring a producer into view or select one": "تولیدکننده‌ای را انتخاب یا وارد دید کنید",
  "Select or build a Strike center": "یک مرکز موشکی بسازید یا انتخاب کنید",
  "No preparation to cancel": "آماده‌سازی‌ای برای لغو موجود نیست",
  "Center already holds a missile": "مرکز از قبل موشک دارد",
  "Center already holds a cruise missile": "مرکز از قبل موشک کروز دارد",
  Refund: "بازپرداخت",
  "Upgrade complete": "ارتقا کامل شد",
  "Another upgrade in progress": "ارتقای دیگری در جریان است",
  "Upgrade unavailable": "ارتقا در دسترس نیست",
  Complete: "کامل",
  "No producer — train or build one first": "تولیدکننده‌ای نیست؛ ابتدا یکی تولید کنید یا بسازید",
  "Select a building to sell": "ساختمانی برای فروش انتخاب کنید",
  "Select a unit": "یک یگان انتخاب کنید",
  Base: "پایگاه",
  Units: "یگان‌ها",
  Economy: "اقتصاد",
  Support: "پشتیبانی",
  Defence: "دفاع",
  Vehicles: "خودروها",
  Air: "هوایی",
  Strike: "حمله",
  "Select the builder — left-click it.": "سازنده را با کلیک چپ انتخاب کنید.",
  "Build a Power plant": "یک نیروگاه بسازید",
  "Build a Supply center": "یک مرکز تدارکات بسازید",
  "The Supply center brings a free Supply truck — right-click a Supply dock to gather.":
    "مرکز تدارکات یک کامیون رایگان دارد؛ برای برداشت روی انبار منابع راست‌کلیک کنید.",
  "Light Machine Gun": "Light Machine Gun",
  "Tank Firing": "Tank Firing",
  "Missle Launch": "Missle Launch",
  Kibblesbob: "Kibblesbob",
  "Public Domain": "Public Domain",
  "2 High Quality Explosions": "2 High Quality Explosions",
  "Michel Baradari": "Michel Baradari",
  "Grenade Explosion": "Grenade Explosion",
  "Mike Koenig": "Mike Koenig",
  "Muffled Distant Explosion": "Muffled Distant Explosion",
  "Bunker Buster Missile": "Bunker Buster Missile",
  "Interface Sounds": "Interface Sounds",
  Kenney: "Kenney",
  "Sci-Fi RTS War Unit Sounds": "Sci-Fi RTS War Unit Sounds",
  "qubodup; Ferdinger, John Sipos, klankbeeld": "qubodup; Ferdinger, John Sipos, klankbeeld",
  "Machine shutting down": "Machine shutting down",
  "Cough-E; PatrickLieberkind": "Cough-E; PatrickLieberkind",
  "100 CC0 SFX #2": "100 CC0 SFX #2",
  "Covert Operations": "Covert Operations",
  "Exploration Theme": "Exploration Theme",
  "Cleyton Kauffman": "Cleyton Kauffman",
  "The Recon Mission": "The Recon Mission",
  "Zander Noriega": "Zander Noriega",
  "Warzone 2100 Unit Voices": "Warzone 2100 Unit Voices",
  "Warzone 2100 Project": "Warzone 2100 Project",
  "GPL-2.0-or-later": "GPL-2.0-or-later",
  "Barlow Condensed ExtraBold Italic": "Barlow Condensed ExtraBold Italic",
  "The Barlow Project Authors (James Puckett)": "The Barlow Project Authors (James Puckett)",
  "SIL OFL 1.1": "SIL OFL 1.1",
  "Art and sound credits": "سازندگان آثار هنری و صدا",
  "Art: procedural and textured 3D models rendered with three.js.":
    "تصویر: مدل‌های سه‌بعدی رویه‌ای و بافت‌دار با three.js نمایش داده می‌شوند.",
  "Audio changes: trimming, silence removal, fades, volume adjustment, and MP3 conversion. Some effects have pitch and filter changes.":
    "تغییرات صدا: برش، حذف سکوت، ورود و خروج تدریجی، تنظیم بلندی و تبدیل به MP3. بعضی جلوه‌ها تغییر زیر و بمی و فیلتر دارند.",
  "Covert Operations contains Apple loops within the composition. No individual loop is distributed.":
    "قطعهٔ Covert Operations در ترکیب خود از حلقه‌های Apple استفاده می‌کند. هیچ حلقه‌ای جداگانه توزیع نمی‌شود.",
  "{0} · YOU": "{0} · شما",
  "Net {0} ms": "شبکه {0} میلی‌ثانیه",
  "Worst link {0} ms": "کندترین اتصال {0} میلی‌ثانیه",
  "{0} · YOU · {1}": "{0} · شما · {1}",
  "Viewing {0}": "در حال مشاهدهٔ {0}",
  "POWER  {0} / {1}": "برق  {0} / {1}",
  "LOW POWER · Training {0}% speed · Defenses offline":
    "کمبود برق · سرعت تولید {0}% · دفاع غیرفعال",
  "BUILDING +{0} use / +{1} supply": "ساخت +{0} مصرف / +{1} تولید",
  "AFTER {0} / {1}": "پس از ساخت {0} / {1}",
  "SHORT {0}": "کمبود {0}",
  "SPARE {0}": "مازاد {0}",
  "LOW POWER · {0} short now{1}": "کمبود برق · اکنون {0} کسری{1}",
  "SHORTAGE · {0} after completion": "کمبود · {0} پس از تکمیل",
  "UNITS {0} · UNLIMITED": "یگان‌ها {0} · نامحدود",
  "UNITS {0} / {1}": "یگان‌ها {0} / {1}",
  "{0} · Unlimited": "{0} · نامحدود",
  "{0} population · Unlimited. Heavy units take more; buildings do not count.":
    "{0} جمعیت · نامحدود. یگان‌های سنگین جای بیشتری می‌گیرند؛ ساختمان‌ها محاسبه نمی‌شوند.",
  "{0} of {1} population. Heavy units take more; buildings do not count.":
    "{0} از {1} جمعیت. یگان‌های سنگین جای بیشتری می‌گیرند؛ ساختمان‌ها محاسبه نمی‌شوند.",
  " · {0} population": " · {0} جمعیت",
  "Missile preparing{0}": "در حال آماده‌سازی موشک{0}",
  "Cruise missile preparing{0}": "در حال آماده‌سازی موشک کروز{0}",
  "No missile · purchase one in the Units tab": "موشکی نیست؛ از زبانهٔ یگان‌ها خریداری کنید",
  "Offline · ": "غیرفعال · ",
  "No time limit": "بدون محدودیت زمان",
  "Remaining {0}": "باقی‌مانده {0}",
  "Ready at Airfield": "آماده در فرودگاه",
  "Returns to Airfield": "به فرودگاه بازمی‌گردد",
  "One payload per mission · Returns to Airfield · Rearms in {0}s":
    "یک شلیک در هر مأموریت · بازگشت به فرودگاه · مسلح‌شدن در {0} ثانیه",
  "Taking off": "در حال برخاستن",
  "On mission": "در مأموریت",
  "Returning to Airfield": "بازگشت به فرودگاه",
  Landing: "در حال فرود",
  Rearming: "در حال مسلح‌شدن",
  "Awaiting Airfield": "در انتظار فرودگاه",
  "Fuel {0}s": "سوخت {0} ثانیه",
  "Moving underground": "حرکت زیر زمین",
  "Holding position": "حفظ موضع",
  Idle: "بیکار",
  " · Split": " · جداشده",
  " · Regrouping": " · بازگشت به آرایش",
  " · Passing terrain": " · عبور از زمین",
  " · Together": " · هماهنگ",
  "Attack-moving": "حرکت تهاجمی",
  Guard: "نگهبانی",
  Follow: "دنبال‌کردن",
  Escort: "اسکورت",
  "Guarding building": "نگهبانی ساختمان",
  "Guarding area": "نگهبانی منطقه",
  Following: "در حال دنبال‌کردن",
  Escorting: "در حال اسکورت",
  "Patrolling ({0} points)": "گشت ({0} نقطه)",
  "Attacking {0}": "حمله به {0}",
  "Capturing {0} · {1}%": "تصرف {0} · {1}%",
  "Approaching {0} to capture": "نزدیک‌شدن به {0} برای تصرف",
  "Entering transport": "ورود به نفربر",
  Building: "در حال ساخت",
  Harvesting: "برداشت منابع",
  "Striking ground": "بمباران زمین",
  "{0} pending orders · {1} repeating patrol routes. Remove each unit's last pending order; the active order stays.":
    "{0} فرمان در انتظار · {1} مسیر گشت تکرارشونده. آخرین فرمان در انتظار هر یگان را حذف کنید؛ فرمان فعال باقی می‌ماند.",
  "Persistent job. Shift+click or Queue appends; later queued orders wait until this job ends, is stopped or replaced.":
    "کار ماندگار. Shift+کلیک یا صف، فرمان را اضافه می‌کند؛ فرمان‌های بعدی تا پایان، توقف یا جایگزینی این کار منتظر می‌مانند.",
  "Unit orders": "فرمان‌های یگان",
  "Defend pursues nearby enemies and returns; Aggressive pursues farther; Hold fires in range without chasing. Changing stance keeps orders.":
    "دفاعی دشمن نزدیک را تعقیب می‌کند و بازمی‌گردد؛ تهاجمی بیشتر تعقیب می‌کند؛ حفظ موضع بدون تعقیب شلیک می‌کند. تغییر حالت فرمان‌ها را حفظ می‌کند.",
  "Mixed stance": "حالت‌های مختلف",
  Defend: "دفاعی",
  "Hold position": "حفظ موضع",
  "Stops orders; prevents chasing.": "فرمان‌ها را متوقف می‌کند؛ مانع تعقیب می‌شود.",
  "Automatic fire off; attack orders still fire.":
    "شلیک خودکار خاموش؛ فرمان حمله همچنان اجازه شلیک می‌دهد.",
  "Guard ground or an owned building; escort an owned unit.":
    "از زمین یا ساختمان خودی نگهبانی کنید؛ یگان خودی را همراهی کنید.",
  Aggressive: "تهاجمی",
  "Hold fire prevents automatic shots and retaliation. Attack and Attack-move allow fire for that order. {0}":
    "عدم شلیک شلیک خودکار و پاسخ به حمله را متوقف می‌کند. حمله و حرکت تهاجمی در همان فرمان اجازهٔ شلیک می‌دهند. {0}",
  "Mixed fire": "آتش مختلف",
  "Stop current and queued orders and adopt Hold position.":
    "فرمان‌های جاری و صف را متوقف و حالت حفظ موضع را فعال می‌کند.",
  "Hold now": "حفظ موضع فوری",
  Formation: "آرایش",
  "Destination formation": "آرایش مقصد",
  Shape: "شکل",
  Spacing: "فاصله",
  "Units fight, then regroup; blocked or late members Split and finish independently.":
    "یگان‌ها می‌جنگند و دوباره آرایش می‌گیرند؛ اعضای دیررس یا مسدود جدا می‌شوند و مستقل ادامه می‌دهند.",
  "Guard area": "نگهبانی منطقه",
  "Guard building": "نگهبانی ساختمان",
  "Follow at an independent offset; no protection promise. {0}":
    "دنبال‌کردن با فاصلهٔ مستقل؛ بدون تعهد دفاع. {0}",
  "Follow and defend around the live target using the current stance. {0}":
    "دنبال‌کردن و دفاع از اطراف هدف زنده با حالت رزمی فعلی. {0}",
  "Replace selected mobile ground units' orders with short legal outward moves. No projectile avoidance guarantee.":
    "فرمان یگان‌های زمینی متحرکِ انتخاب‌شده را با حرکت‌های کوتاه مجاز به بیرون جایگزین می‌کند. فرار از پرتابه تضمین نمی‌شود.",
  "Scatter · ": "پراکنده‌شدن · ",
  "Cancel last queued": "لغو آخرین فرمان صف",
  "More unit orders": "فرمان‌های بیشتر یگان",
  "Unit behavior": "رفتار یگان",
  "Follow an owned unit without guarding it.": "یک یگان خودی را بدون نگهبانی از آن دنبال کنید.",
  "Move together on the next order. Turn off to move independently.":
    "در فرمان بعدی هماهنگ حرکت کنید. برای حرکت مستقل خاموش کنید.",
  "Remove the last pending order; keep the active order.":
    "آخرین فرمان در انتظار را حذف کنید؛ فرمان فعال را نگه دارید.",
  "Guard, follow and escort targeting": "هدف‌گیری نگهبانی، دنبال‌کردن و اسکورت",
  "Keyboard target": "هدف‌گیری با صفحه‌کلید",
  "Or choose a target on the map.": "یا هدفی را روی نقشه انتخاب کنید.",
  "Guard anchor X": "مختصات X نقطهٔ نگهبانی",
  "Guard anchor Y": "مختصات Y نقطهٔ نگهبانی",
  "Owned guard, follow or escort target": "هدف خودی برای نگهبانی، دنبال‌کردن یا اسکورت",
  "Selection tools": "ابزارهای انتخاب",
  "Combat on screen": "رزمی‌های در دید",
  "All combat": "همهٔ رزمی‌ها",
  "Idle combat": "رزمی‌های بیکار",
  "Select combat units without orders, patrols, ongoing fire, or enemies in acquisition range.":
    "یگان‌های رزمی بدون فرمان، گشت، شلیک جاری یا دشمن در برد شناسایی را انتخاب کنید.",
  "Guard and escort pursuit radius": "شعاع تعقیب نگهبانی و اسکورت",
  "Radius 160 · short": "شعاع 160 · کوتاه",
  "Radius 320 · normal": "شعاع 320 · عادی",
  "Radius 640 · wide": "شعاع 640 · وسیع",
  Issue: "صدور",
  Queue: "صف",
  "Cancel targeting": "لغو هدف‌گیری",
  "Filter selection": "فیلتر انتخاب",
  "Damaged only": "فقط آسیب‌دیده",
  "Hide tips": "پنهان‌کردن راهنما",
  "Cancel last": "لغو آخرین",
  Scatter: "پراکنده‌شدن",
  Empty: "خالی",
  "Group {0}: empty": "گروه {0}: خالی",
  "Group {0} updated · {1} member{2}": "گروه {0} به‌روز شد · {1} عضو",
  "Group {0} cleared": "گروه {0} پاک شد",
  "Group {0} updated · {1} members": "گروه {0} به‌روز شد · {1} عضو",
  "All ten groups are in use": "هر ده گروه استفاده شده‌اند",
  "Group {0} is empty": "گروه {0} خالی است",
  "Group {0}{1}: {2} · {3}{4}": "گروه {0}{1}: {2} · {3}{4}",
  "Group {0}{1}: empty": "گروه {0}{1}: خالی",
  "Command rejected · Check the position and resources":
    "فرمان پذیرفته نشد · موقعیت و منابع را بررسی کنید",
  "Unit ready": "یگان آماده است",
  "Unit ready · {0}": "یگان آماده است · {0}",
  "Construction complete": "ساخت کامل شد",
  "Construction complete · {0}": "ساخت کامل شد · {0}",
  Tip: "نکته",
  "BASE UNDER ATTACK": "پایگاه مورد حمله است",
  "UNIT UNDER ATTACK": "یگان مورد حمله است",
  "Low power · Production at 25%": "کمبود برق · تولید با سرعت 25%",
  "Player {0}": "بازیکن {0}",
  "Hover battery": "سامانهٔ شناور",
  "Petrel bomber": "بمب‌افکن مرغ طوفان",
  "Recon drone": "پهپاد شناسایی",
  "Strike drone": "پهپاد انتحاری",
  "Bombard walker": "بومبارد",
  Engineer: "مهندس",
  "Builder vehicle": "خودروی سازنده",
  "Supply truck": "کامیون تدارکات",
  "Rifle infantry": "تفنگدار",
  "Rocket infantry": "راکت‌انداز",
  Grenadier: "نارنجک‌انداز",
  Strider: "گام‌زن",
  "Raider buggy": "باگی مهاجم",
  "Oil derrick": "دکل نفتی",
  "Repair depot": "مرکز تعمیرات",
  "Sensor relay": "ایستگاه حسگر",
  "Money crate": "جعبهٔ اعتبار",
  Airfield: "فرودگاه",
  "SAM site": "سامانهٔ ضدهوایی",
  "Strike center": "مرکز موشکی",
  Wall: "دیوار",
  "Trade post": "پست تجاری",
  "Radar station": "ایستگاه رادار",
  "RADAR OFFLINE": "رادار خاموش",
  "Build a Radar station": "ایستگاه رادار بسازید",
  "Command center": "مقر فرماندهی",
  "Power plant": "نیروگاه",
  "Supply center": "مرکز تدارکات",
  Barracks: "پادگان",
  "Vehicle factory": "کارخانهٔ خودرو",
  "Modular tower": "برج ماژولار",
  Bastion: "باستین",
  Low: "کم",
  Medium: "متوسط",
  High: "زیاد",
  Slow: "آهسته",
  Normal: "عادی",
  Fast: "سریع",
  Blue: "آبی",
  Red: "قرمز",
  Gold: "طلایی",
  Purple: "بنفش",
  Green: "سبز",
  Open: "خالی",
  Ready: "آماده",
  "Not ready": "آماده نیست",
  Away: "قطع اتصال",
  Human: "انسان",
  AI: "هوش مصنوعی",
  "AI · {0}": "هوش مصنوعی · {0}",
  easy: "آسان",
  normal: "عادی",
  hard: "سخت",
  attack: "حمله",
  defend: "دفاع",
  look: "توجه",
  ATTACK: "حمله",
  DEFEND: "دفاع",
  LOOK: "توجه",
  Language: "زبان",
  Free: "آزاد",
  Line: "خطی",
  Column: "ستونی",
  Wedge: "گوه‌ای",
  Tight: "فشرده",
  Standard: "استاندارد",
  Wide: "باز",
  Unarmed: "بدون سلاح",
  "Damage varies with target armor": "آسیب با زره هدف تغییر می‌کند",
  " power": " برق",
  "Order not sent ({0}).": "فرمان ارسال نشد ({0}).",
  "Missile strike rejected · {0}": "حملهٔ موشکی پذیرفته نشد · {0}",
  "{0}% refund": "بازپرداخت {0}%",
  " · {0} complete": " · {0} کامل شد",
  "{0}×{1} · {2} owners": "{0}×{1} · {2} بازیکن",
  "(no hotkey)": "(بدون کلید میان‌بر)",
  "{0} (no hotkey)": "{0} (بدون کلید میان‌بر)",
  player: "بازیکن",
  "combined team score": "امتیاز مجموع تیم",
  score: "امتیاز",
  "free-for-all": "همه علیه همه",
  teams: "تیمی",
  may: "می‌توانند",
  cannot: "نمی‌توانند",
  "Blue vs Red": "آبی در برابر قرمز",
  north: "شمال",
  south: "جنوب",
  east: "شرق",
  west: "غرب",
  North: "شمال",
  South: "جنوب",
  East: "شرق",
  West: "غرب",
  NW: "شمال‌غرب",
  NE: "شمال‌شرق",
  SW: "جنوب‌غرب",
  SE: "جنوب‌شرق",
  Northwest: "شمال‌غرب",
  Northeast: "شمال‌شرق",
  Southwest: "جنوب‌غرب",
  Southeast: "جنوب‌شرق",
  light: "سبک",
  heavy: "سنگین",
  infantry: "پیاده‌نظام",
  building: "ساختمان",
  paused: "متوقف",
  disconnected: "قطع اتصال",
  unavailable: "در دسترس نیست",
  "build-mismatch": "اختلاف نسخه",
  "no-room": "اتاق موجود نیست",
  "no-session": "نشست موجود نیست",
  "not-ready": "آماده نیست",
  "already-used": "قبلاً استفاده شده",
  "not-eligible": "واجد شرایط نیست",
  "insufficient-money": "اعتبار ناکافی",
  "outside-map": "خارج از نقشه",
  "game-over": "بازی تمام شده",
  "invalid-target": "هدف نامعتبر",
  "no-builder": "سازنده موجود نیست",
  blocked: "مسدود",
  expired: "منقضی",
  replaced: "جایگزین‌شده",
  kicked: "اخراج‌شده",
  capacity: "ظرفیت پر",
  timeout: "پایان مهلت",
  "rate-limit": "محدودیت تعداد درخواست",
  "Four Corners": "چهارگوشه",
  Triad: "سه‌گانه",
  Mesa: "فلات",
  Alpine: "کوهستان برفی",
  Wetlands: "تالاب",
  Caldera: "دهانهٔ آتشفشان",
  Pentagon: "پنج‌ضلعی",
  "Eight fronts": "هشت جبهه",
  "Eight Fronts": "هشت جبهه",
  Crossroads: "چهارراه",
  "{0} placed · {1} excluded · {2} failed · {3} adapted":
    "{0} جای‌گذاری · {1} مستثنا · {2} ناموفق · {3} تطبیق‌یافته",
  "{0} formation order{1} pending": "{0} فرمان آرایش در انتظار",
  "{0} · {1}s remaining": "{0} · {1} ثانیه باقی‌مانده",
  "{0} applied · {1} excluded · {2} failed": "{0} اعمال‌شده · {1} مستثنا · {2} ناموفق",
  "{0} waypoints · {1} queued": "{0} نقطهٔ مسیر · {1} در صف",
  "frame rejected at tick {0} ({1})": "بستهٔ فرمان در تیک {0} پذیرفته نشد ({1})",
  "invalid command result at tick {0} ({1})": "نتیجهٔ فرمان نامعتبر در تیک {0} ({1})",
  "checkpoint mismatch at tick {0}": "ناهماهنگی نقطهٔ بررسی در تیک {0}",
  "{0} · click selects · double-click centers · right-click for more · drop units here to add":
    "{0} · کلیک: انتخاب · دوبارکلیک: مرکز دوربین · راست‌کلیک: گزینه‌های بیشتر · یگان‌ها را برای افزودن اینجا رها کنید",
  "{0} / {1} HP": "{0} / {1} سلامت",
  "{0} in training": "{0} در حال تولید",
  " · {0} passengers": " · {0} مسافر",
  "{0} {1}: {2} applied, {3} excluded.": "{0} {1}: {2} اعمال‌شده، {3} مستثنا.",
  "{0} applied.": "{0} اعمال شد.",
  "{0} rejected ({1}).": "{0} پذیرفته نشد ({1}).",
  "AA ×{0}": "ضدهوایی ×{0}",
  "{0} HP/s": "{0} سلامت/ثانیه",
  "HP {0} · {1} armor": "سلامت {0} · زره {1}",
  " · Speed {0} / s": " · سرعت {0} در ثانیه",
  " · +{0} range · Takes {1}% damage": " · +{0} برد · دریافت {1}% آسیب",
  "{0} eliminated": "{0} حذف شد",
  "tick {0}{1}": "تیک {0}{1}",
  " · {0} command{1} pending": " · {0} فرمان در انتظار",
  " · pauses used {0}/{1}": " · توقف مصرف‌شده {0}/{1}",
  "tick {0}": "تیک {0}",
  "{0} players": "{0} بازیکن",
  "{0} AI · {1}": "{0} هوش مصنوعی · {1}",
  "{0}{1} · {2} of {3} seats taken": "{0}{1} · {2} از {3} جایگاه گرفته‌شده",
  "{0} ms": "{0} میلی‌ثانیه",
  "{0} destroyed every enemy building.": "{0} تمام ساختمان‌های دشمن را نابود کرد.",
  " — {0} wins.": " — {0} پیروز شد.",
  "A side resigned{0}": "یک جناح تسلیم شد{0}",
  "A side left{0}": "یک جناح خارج شد{0}",
  "A side disconnected{0}": "اتصال یک جناح قطع شد{0}",
  " · eliminated at {0}": " · حذف در {0}",
  "the team of {0}": "تیم {0}",
  "{0} {1} the {2} — every enemy building is destroyed.":
    "{0} {2} {1}؛ همهٔ ساختمان‌های دشمن نابود شده‌اند.",
  "{0} resigned": "{0} تسلیم شد",
  "{0} left the match": "{0} نبرد را ترک کرد",
  "{0} disconnected": "اتصال {0} قطع شد",
  "{0} · lane {1}": "{0} · مسیر {1}",
  "{0} roster": "فهرست یگان‌های {0}",
  "AI · {0} · {1}": "هوش مصنوعی · {0} · {1}",
  "{0} · builder + hauler · once per match": "{0} · سازنده + کامیون · یک بار در هر نبرد",
  "{0} production": "تولید {0}",
  "{0}% · {1}s left{2}": "{0}% · {1} ثانیه باقی‌مانده{2}",
  " by {0}. ": " اثر {0}. ",
  "{0} · worst link {1} ms": "{0} · کندترین اتصال {1} میلی‌ثانیه",
  " · {0} short after completion": " · {0} کسری پس از تکمیل",
  "{0} missile{1} ready · select a target": "{0} موشک آماده · هدف را انتخاب کنید",
  "{0} cruise missile{1} ready · select a target": "{0} موشک کروز آماده · هدف را انتخاب کنید",
  "{0} ended · {1}": "{0} پایان یافت · {1}",
  "{0} · mixed": "{0} · ترکیبی",
  "{0} pending.": "{0} در انتظار است.",
  "{0}: {1} applied, {2} excluded, {3} failed or stale.":
    "{0}: {1} اعمال‌شده، {2} مستثنا، {3} ناموفق یا منقضی.",
  "{0}% HP": "سلامت {0}%",
  "Saffron Mesa": "فلات زعفران",
  "Frostline Pass": "گذرگاه یخبندان",
  "Jade Delta": "دلتای یشم",
  "Obsidian Caldera": "دهانهٔ ابسیدین",
  "Twin Marches": "دو جبهه",
  HP: "سلامت",
  "HP ": "سلامت ",
  "have conquered": "فتح کرده‌اید",
  "has conquered": "فتح کرده است",
  battlefield: "میدان نبرد",
  victory: "پیروزی",
  "the winner": "برنده",
  applied: "اعمال‌شده",
  rejected: "پذیرفته‌نشده",
  " · adapted": " · تطبیق‌یافته",
  auto: "خودکار",
  "Air only": "فقط هوایی",
  "Ground + air": "زمینی و هوایی",
  "Ground only": "فقط زمینی",
  win: "پیروز شدید",
  wins: "پیروز شد",
  you: "شما",
  "your team": "تیم شما",
  are: "هستید",
  is: "است",
  "last team standing": "آخرین تیم باقی‌مانده",
  "last owner standing": "آخرین بازیکن باقی‌مانده",
  "A player resigned": "یک بازیکن تسلیم شد",
  "A player left the match": "یک بازیکن نبرد را ترک کرد",
  "A player disconnected": "اتصال یک بازیکن قطع شد",
  "{0} — {1} {2}.": "{0} — {1} {2}.",
  "Razmak strategy game": "بازی استراتژیک رزمک",
  "north-west": "شمال‌غرب",
  "north-east": "شمال‌شرق",
  "south-west": "جنوب‌غرب",
  "south-east": "جنوب‌شرق",
  "humans only": "فقط انسان",
  optional: "اختیاری",
  "an integer": "یک عدد صحیح",
  "a number": "یک عدد",
  "That saved match names no valid side.": "این ذخیره جناح معتبری ندارد.",
  "renderer unavailable": "نمایشگر در دسترس نیست",
  "final hash mismatch": "ناهماهنگی هش نهایی",
  "winner mismatch": "ناهماهنگی برنده",
  "match ended before final tick": "نبرد پیش از تیک نهایی تمام شد",
  " · Builder assigned": " · سازنده تعیین شده است",
  " · Builder queued — finishes current work first":
    " · سازنده در صف است؛ ابتدا کار فعلی را تمام می‌کند",
  " · Unattended — select a builder and right-click to resume":
    " · بدون سازنده؛ سازنده را انتخاب و برای ادامه راست‌کلیک کنید",
  " · Paused: low power": " · متوقف: کمبود برق",
  " · Must deploy to fire": " · برای شلیک باید مستقر شود",
  " including paid queues": " با احتساب صف‌های خریداری‌شده",
  "A name needs 2–16 characters, or leave it blank.":
    "نام باید 2 تا 16 نویسه داشته باشد؛ یا آن را خالی بگذارید.",
  "A room code is 6 letters or digits.": "کد اتاق 6 حرف یا رقم است.",
  "guest (assigned on join)": "مهمان (هنگام پیوستن تعیین می‌شود)",
  "A saved match lets you keep playing from that moment. ":
    "فایل ذخیره به شما اجازه می‌دهد از همان لحظه ادامه دهید. ",
  "A battle record replays exactly what happened — watching ends the current battle, ":
    "بازپخش همان رویدادهای نبرد را نشان می‌دهد؛ تماشا نبرد فعلی را تمام می‌کند، ",
  "and your orders stay locked while watching.": "و هنگام تماشا نمی‌توانید فرمان بدهید.",
  "Faction access": "دسترسی جناح",
  Producer: "ساختمان تولید یگان",
  "Not sufficient money": "اعتبار کافی نیست",
  " · paused by low power": " · متوقف به دلیل کمبود برق",
  " · Under attack": " · مورد حمله",
  center: "مرکز",
  "… ms": "… میلی‌ثانیه",
  ready: "آماده",
  missing: "موجود نیست",
  "{0} {1} ({2}).": "{0} {1} ({2}).",
  "Settings sections": "بخش‌های تنظیمات",
  Sound: "صدا",
  Gameplay: "نحوهٔ بازی",
  Controls: "کنترل‌ها",
  "Menu and match music": "موسیقی منو و نبرد",
  "Weapons, units, interface": "سلاح‌ها، یگان‌ها و رابط کاربری",
  "Unit and alert callouts": "اعلام یگان‌ها و هشدارها",
  "Skirmish and training only": "فقط در نبرد سریع و آموزش",
  "Lower it on weak devices": "روی دستگاه‌های ضعیف کمتر انتخاب کنید",
  "Text size": "اندازه متن",
  "Range overlays": "نمایش محدوده‌ها",
  "Solid sight boundary, dashed weapon range": "خط پیوسته دید، خط‌چین برد سلاح",
  "HUD size": "اندازه رابط",
  "Scales every panel and button in a match": "اندازه همه پنل‌ها و دکمه‌های بازی را تغییر می‌دهد",
  "Fade panels": "محو شدن پنل‌ها",
  "Dim panels while your units or a drag box pass under them":
    "پنل‌ها را زمانی که یگان‌های شما یا کادر انتخاب از زیر آن‌ها می‌گذرند کم‌رنگ کنید",
  "Saved match": "بازی ذخیره‌شده",
  "Battle record": "بازپخش نبرد",
  Structures: "ساختمان‌ها",
  Cost: "هزینه",
  "{0} player is not ready": "{0} بازیکن آماده نیست",
  "{0} players are not ready": "{0} بازیکن آماده نیستند",
  Waiting: "در انتظار",
  "Open seat": "جایگاه خالی",
  "Online match": "نبرد آنلاین",
  Alerts: "هشدارها",
  "Alert history": "تاریخچه هشدارها",
  "View alert: {0}": "مشاهده هشدار: {0}",
  "{0}P": "{0}ن",
  PWR: "برق",
  POP: "جمعیت",
  "Idle bld": "سازنده",
  "▼ 25%": "▼ 25%",
  "Mechanics and counters": "مکانیک بازی و جدول آسیب",
  "Statistics and counters": "آمار و جدول آسیب",
  Mechanics: "مکانیک بازی",
  "Damage per hit by target armor": "آسیب هر ضربه بر اساس زره هدف",
  Armor: "زره",
  Multiplier: "ضریب",
  Ground: "زمینی",
  "Per hit against an unranked, undeployed target; excludes splash and healing.":
    "برای هر ضربه به هدفی بدون درجه و بدون استقرار؛ بدون آسیب منطقه‌ای و ترمیم.",
  "Sight and terrain": "دید و زمین",
  "Select a unit to inspect its solid sight boundary and dashed weapon reach. Minimum range uses a second inner ring.":
    "یک یگان را انتخاب کنید تا مرز دید پیوسته و برد خط‌چین سلاح آن بررسی شود. برد کمینه با یک حلقهٔ درونی دوم نشان داده می‌شود.",
  "Ground sight filters high target cells and distant canopy. Aircraft ignore these checks. This is not full terrain ray tracing.":
    "دید زمینی خانه‌های بلندترِ هدف و پوشش گیاهی دور را می‌پوشاند. هواگردها این بررسی‌ها را نادیده می‌گیرند. این ردیابی کامل پرتو در زمین نیست.",
  Deployment: "استقرار",
  "Use the Deploy order tile on a deployable unit. Some weapons require deployment; movement first requires undeployment.":
    "کاشی فرمان «استقرار» را روی یگان قابل استقرار به کار ببرید. برخی سلاح‌ها به استقرار نیاز دارند؛ حرکت نخست به جمع‌کردن استقرار نیاز دارد.",
  "Deployment time and range use the active match settings. Inspect the unit statistics for its exact values.":
    "زمان و برد استقرار از تنظیمات فعال مسابقه می‌آید. برای مقادیر دقیق، آمار یگان را بررسی کنید.",
  "Select infantry and order it into a friendly transport. Use Unload ({0}) on the transport to release passengers.":
    "پیاده‌نظام را انتخاب کنید و به داخل حامل خودی فرمان دهید. با «پیاده‌کردن» ({0}) روی حامل، سرنشینان آزاد می‌شوند.",
  "Aircraft service": "سرویس هواگردها",
  "Aircraft carry finite payloads. Use Resupply to return to an Airbase; inspect its service state before another mission.":
    "هواگردها بار مفید محدودی حمل می‌کنند. برای بازگشت به پایگاه هوایی «تجدید مهمات» را به کار ببرید؛ پیش از مأموریت بعدی وضعیت سرویس را بررسی کنید.",
  "Weapon reload and Airbase rearm time are different. The statistics identify the applicable service time.":
    "بارگیری مجدد سلاح و زمان تسلیح دوباره در پایگاه هوایی متفاوت‌اند. آمار، زمان سرویس مربوط را مشخص می‌کند.",
  Veterancy: "کهارت",
  "Surviving units gain experience from their share of destroyed enemy value. Ranks increase outgoing damage and reduce incoming damage.":
    "یگان‌های بازمانده از سهم خود از ارزش دشمنانِ نابودشده تجربه می‌گیرند. درجه‌ها آسیبِ واردشده را زیاد و آسیبِ دریافتی را کم می‌کنند.",
  "Each rank: +{0}% damage and −{1}% incoming damage. Heroic units can regenerate.":
    "هر درجه: +{0}٪ آسیب و −{1}٪ آسیب دریافتی. یگان‌های قهرمان می‌توانند خود را ترمیم کنند.",
  "Use First Mission under Learn to play for practical training.":
    "برای آموزش عملی، «اولین مأموریت» را در «آموزش بازی» به کار ببرید.",
  "Weapon cannot engage air targets": "سلاح نمی‌تواند هدف‌های هوایی را درگیر کند",
  "Weapon cannot engage ground targets": "سلاح نمی‌تواند هدف‌های زمینی را درگیر کند",
  "Objective captured · +{0}": "هدف تصرف شد · +{0}",
  "Objective lost · {0}": "هدف از دست رفت · {0}",
  "Building lost · {0}": "ساختمان از دست رفت · {0}",
  "Buildings lost · {0}": "ساختمان‌های از دست رفته · {0}",
  "Hold fire · will not shoot": "آتش در نگه‌داشته · شلیک نمی‌کند",
  "Cannot fire until deployed": "تا مستقر نشود شلیک نمی‌کند",
  "Target inside minimum range · {0}": "هدف داخل برد کمینه · {0}",
  "Last seen {0}s ago": "آخرین مشاهده {0} ثانیه پیش",
  "Battle timeline": "خط زمانی نبرد",
  "{0} · {1} eliminated": "{0} · {1} حذف شد",
  "{0} · {1} headquarters destroyed": "{0} · ستاد فرماندهی {1} نابود شد",
  "{0} · {1} lost {2}": "{0} · {1} {2} را از دست داد",
  "{0} · {1} captured {2}": "{0} · {1} {2} را تصرف کرد",
  "{0} · {1} took {2} from {3}": "{0} · {1} {2} را از {3} گرفت",
  "{0} · {1} destroyed": "{0} · {1} نابود شد",
  "{0} · {1} owned by {2} destroyed": "{0} · {1} متعلق به {2} نابود شد",
  "{0} · {1} collected {2}": "{0} · {1} {2} رو برداشت",
  "Borderlands: two mirrored bases flank a central river. Secure the crossings and contest the northern derricks.":
    "سرزمین مرزی: دو پایگاه آینه‌ای دو سوی رود مرکزی. گذرگاه‌ها را تأمین و دیرک‌های شمالی را رقابت کنید.",
};

export const en: Record<string, string> = Object.fromEntries(
  Object.keys(fa).map((key) => [key, key]),
);
